<template>
  <div>
    <div class="flex flex-col items-start gap-[26px]">
      <!-- Breadcrumb -->
      <Breadcrumb />
      <!-- Breadcrumb -->

      <div class="w-full flex flex-col items-start gap-[26px]" ref="pdfRef">
        <div class="w-full flex flex-col items-start gap-[20px]">
          <div class="w-full flex flex-col items-start gap-[6px]">
            <div class="PC_H2-SB text-[#1F1D1F]">
              แบบบันทึกเวชระเบียนของทีมปฏิบัติการฉุกเฉิน
              <!-- {{ route.query.from }} -->
              <!-- {{ userData?.fullname }} -->
            </div>
            <div class="PC_H3-R text-[#1F1D1F]">(Medical Data Sheet+)</div>
          </div>
          <div class="w-full flex items-center gap-[8px]">
            <div v-if="isEdit" class="flex flex-row items-start gap-[8px] flex-wrap">
              <div class="mt-[8px] title">วันที่ประเมิน</div>
              <div class="set380 min-w-[257px]">
                <DatePicker2 :modelValue="form.datetime" @update:modelValue="(date) => selectCreateDate(date)" />
                <div v-if="errors.datetime" class="textError mt-[8px]">
                  {{ errors.datetime }}
                </div>
              </div>
            </div>
            <div v-else class="w-full flex items-center justify-between gap-[12px] flex-wrap sm:flex-nowrap">
              <div class="flex items-center gap-[20px] flex-wrap sm:flex-nowrap">
                <div class="flex flex-col">
                  <div class="PC_Body2-R text-[#7C7379]">ครั้งที่</div>
                  <div class="PC_Body1-R text-[#1F1D1F]">{{ assessment_count || 0 }}</div>
                </div>
                <div class="h-[47px] border-r-1 border-[#DFDCDD]"></div>
                <div class="flex flex-col">
                  <div class="PC_Body2-R text-[#7C7379]">วันที่ประเมิน</div>
                  <div class="PC_Body1-R text-[#1F1D1F]">
                    {{ $formatDate4(form.datetime) }}
                  </div>
                </div>
                <div class="w-full sm:w-fit flex items-center gap-[10px]">
                  <button v-if="isOffline == false" @click="openLog()"
                    class="no-export h-[42px] w-fit text-[#1F1D1F] M border border-[#B7B2B5] px-[16px] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]">
                    ประวัติการแก้ไข
                  </button>
                  <button @click="changeMode(true)"
                    class="no-export h-[42px] w-[76px] text-white M bg-[#9B237B] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]">
                    แก้ไข
                  </button>
                </div>
              </div>
              <div v-if="isOffline == false" class="no-export">
                <button @click="downloadPdf()"
                  class="h-[42px] w-fit text-[#1F1D1F] M border border-[#B7B2B5] px-[16px] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5] flex items-center justify-center gap-[6px]">
                  <DownloadIcon class="w-[20px] h-[20px] text-primary" /> ดาวน์โหลดรายงาน
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-col-reverse sm:flex-row gap-[26px] items-start flex-wrap sm:flex-nowrap">
          <div class="w-full flex flex-col">
            <!-- {{ isEdit }} -->
            <!-- {{ viewLists }} -->
            <!-- 2. การเจ็บป่วย -->
            <!-- {{ form }} -->
            <div v-if="
              isEdit == true ||
              viewLists.trauma.length > 0 ||
              viewLists.infectious.length > 0 ||
              viewLists.urgent.length > 0 ||
              viewLists.otherMajor.length > 0 ||
              form.illness.extraNote ||
              isOnline == false
            " class="w-full flex flex-col items-start gap-[20px]">
              <div class="w-full p-[10px] bg-[#FBEFF8]">
                <label class="PC_Body1-SB text-[#1F1D1F]">
                  <span v-if="!isEdit" class="sm:hidden">2.</span> การเจ็บป่วย
                  <span class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                    errors?.illness?.message || ""
                  }}</span></label>
              </div>

              <!-- //อุบัติเหตุ (Trauma) -->
              <div v-if="isEdit || viewLists.trauma.length > 0" class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]"> อุบัติเหตุ (Trauma) </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in traumaOptions" :key="opt.value" v-model="form.illness.trauma" :value="opt.value"
                  :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.trauma.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.trauma" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in traumaOptions" :key="opt.value" v-model="form.illness.trauma" :value="opt.value"
              :label="opt.label" :disabled="!isEdit" /> -->

              <!-- // โรคติดเชื้อ (Infectious disease) -->
              <div v-if="isEdit || viewLists.infectious.length > 0"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">
                  โรคติดเชื้อ (Infectious disease)
                </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in infectiousOptions" :key="opt.value" v-model="form.illness.infectious"
                  :value="opt.value" :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.infectious.length > 0" class="flex flex-col items-start gap-[20px] fontSize14">
                <div v-for="data in viewLists.infectious" :key="data.value" class="page-keep flex items-center">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in infectiousOptions" :key="opt.value" v-model="form.illness.infectious" :value="opt.value"
              :label="opt.label" :disabled="!isEdit" /> -->

              <!-- //โรคฉุกเฉิน -->
              <div v-if="isEdit || viewLists.urgent.length > 0" class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">โรคฉุกเฉิน </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in urgentOptions" :key="opt.value" v-model="form.illness.urgent" :value="opt.value"
                  :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.urgent.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.urgent" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in urgentOptions" :key="opt.value" v-model="form.illness.urgent" :value="opt.value"
              :label="opt.label" :disabled="!isEdit" /> -->

              <!-- // โรคสำคัญอื่นๆ -->
              <div v-if="isEdit || viewLists.otherMajor.length > 0"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]"> โรคสำคัญอื่นๆ </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in otherMajorOptions" :key="opt.value" v-model="form.illness.otherMajor"
                  :value="opt.value" :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.otherMajor.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.otherMajor" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in otherMajorOptions" :key="opt.value" v-model="form.illness.otherMajor" :value="opt.value"
              :label="opt.label" :disabled="!isEdit" /> -->

              <div v-if="isEdit || form.illness.extraNote" class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">เพิ่มเติม</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="ไม่บังคับ" v-model="form.illness.extraNote" :disabled="!isEdit && isOnline == true"
                  :warningMessage="errors.max_capacity" />
              </div>
              <div v-else-if="!isEdit && form.illness.extraNote" class="page-keep flex items-center">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ form.illness.extraNote }}
              </div>

              <!-- <Input placeholder="ไม่บังคับ" v-model="form.illness.extraNote" :disabled="!isEdit"
              :warningMessage="errors.max_capacity" /> -->
            </div>

            <!-- 3. หัตถการและผลการรักษา -->
            <!-- viewLists.outcomes.length > 0 -->
            <div v-if="
              isEdit || viewLists.procedures.length > 0 || viewLists.outcomes.length > 0
            " class="mt-[26px] w-full flex flex-col items-start gap-[20px]">
              <div class="page-keep w-full p-[10px] bg-[#FBEFF8]">
                <label class="PC_Body1-SB text-[#1F1D1F]"> <span v-if="!isEdit" class="sm:hidden">3.</span> หัตถการและผลการรักษา</label>
              </div>

              <!-- //หัตถการ -->
              <div v-if="isEdit || viewLists.procedures.length > 0" class="w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]"> หัตถการ </span>
              </div>

              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in procedureOptions" :key="opt.value" v-model="form.care.procedures"
                  :value="opt.value" :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.procedures.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.procedures" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in procedureOptions" :key="opt.value" v-model="form.care.procedures" :value="opt.value"
          :label="opt.label" :disabled="!isEdit" /> -->
              <div v-if="isEdit || image" class="flex flex-col items-center gap-[8px]">
                <div v-if="isEdit" class="w-full flex items-center gap-[10px]">
                  <span class="PC_Body1-SB text-[#1F1D1F]"> แนบรูป </span>
                </div>
                <UploadImage2 
                v-model:image="image" 
                @update:fileSizeMB="
                (res)=>{
                  imageSize = res;
                }" 
                :fileSizeMB="imageSize" 
                :editable="isEdit" 
                :type="2" @update:image="
                  (res) => {
                    image = res;
                  }
                " />
              </div>
              <!-- //ผลการรักษา -->
              <div v-if="isEdit || viewLists.outcomes.length > 0" class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">ผลการรักษา</span>
                <span class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                  errors.care.outcomesMessage
                }}</span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in outcomeOptions" :key="opt.value" v-model="form.care.outcomes" :value="opt.value"
                  :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.outcomes.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.outcomes" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
              <!-- <CheckBox v-for="opt in outcomeOptions" :key="opt.value" v-model="form.care.outcomes" :value="opt.value"
          :label="opt.label" :disabled="!isEdit" /> -->
            </div>

            <!-- 4. บริบท -->
            <div v-if="
              isEdit ||
              viewLists.relationships.length > 0 ||
              viewLists.prevention.length > 0 ||
              form.context.extraNote ||
              isOnline == false
            " class="mt-[26px] w-full flex flex-col items-start gap-[20px]">
              <div class="page-keep w-full p-[10px] bg-[#FBEFF8]">
                <label class="PC_Body1-SB text-[#1F1D1F]"> <span v-if="!isEdit" class="sm:hidden">4.</span> บริบท</label>
              </div>

              <!-- // ความสัมพันธ์ -->
              <div v-if="isEdit || viewLists.relationships.length > 0"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]"> ความสัมพันธ์ </span>
                <span class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                  errors.context.relationshipsMessage
                }}</span>
              </div>

              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in relationshipOptions" :key="opt.value" v-model="form.context.relationships"
                  :value="opt.value" :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.relationships.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.relationships" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>

              <!-- //การป้องกัน -->
              <div v-if="isEdit || viewLists.prevention.length > 0"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">การป้องกัน</span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
                <CheckBox v-for="opt in preventionOptions" :key="opt.value" v-model="form.context.prevention"
                  :value="opt.value" :label="opt.label" :disabled="!isEdit && isOnline == true" />
              </div>
              <div v-else-if="viewLists.prevention.length > 0" class="flex flex-col items-start gap-[20px]">
                <div v-for="data in viewLists.prevention" :key="data.value" class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ data }}
                </div>
              </div>
            </div>
            <!-- //บันทึกเพิ่มเติม  -->
            <div class="mt-[26px] w-full flex flex-col items-start gap-[20px]">
              <div v-if="isEdit || form.context.extraNote" class="page-keep w-full flex items-center gap-[10px]">
              <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <label class="PC_Body1-SB text-[#1F1D1F]"> บันทึกเพิ่มเติม</label>
              </div>

              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="ไม่บังคับ" v-model="form.context.extraNote" :disabled="!isEdit"
                  :warningMessage="errors.max_capacity" />
              </div>

              <div v-else-if="!isEdit && form.context.extraNote" class="page-keep flex items-center mb-[26px] fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ form.context.extraNote }}
              </div>
            </div>

            <!-- <div v-if="!isEdit" class="mb-[26px] w-full border border-[#DFDCDD] border-dashed"></div> -->

            <div v-if="(!isEdit && isOnline == true) && isOffline == false" class="page-keep w-full flex items-center gap-[10px]">
              <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
              <span class="PC_Body1-SB text-[#1F1D1F]">ผู้ลงข้อมูล</span>
            </div>

            <!-- <div v-if="!isEdit" class="pdf-sentinel mt-[20px] flex flex-col items-start gap-[20px]">
              {{ created_name || "-" }}
            </div> -->
            <div v-if="(!isEdit && isOnline == true) && isOffline == false" class="mt-[20px] flex flex-col items-start gap-[20px] fontSize14">
              {{ created_name || profileData.fullname || "-" }}
            </div>
          </div>
          <div class="w-full border-[1px] border-[#B7B2B5] rounded-[6px] flex flex-col max-[640px]:border-[0px]">
            <!-- info -->

            <div class="w-full flex flex-col items-start min-[700px]:p-4">
              <div class="w-full p-[10px] bg-[#FBEFF8]">
                <span class="PC_Body1-SB text-[#1F1D1F]"><span v-if="!isEdit" class="sm:hidden">1.</span> ข้อมูลพื้นฐาน </span>
              </div>
              <div class="w-full max-[500px]:flex-col flex items-start max-[500px]:items-center gap-[20px]">
                <!-- {{ isOnline }} -->
                <!-- {{ isOffline }} -->
                <div v-if="(isOnline == true || (isOffline == false || !isEdit) || !isEdit)"
                  class="my-[20px] min-w-[100px] min-h-[100px] w-[100px] h-[100px] border-[1px] border-solid border-[#F2E7F9]">
                  <img :src="userProfile.image || logo" alt="" />
                  <!-- <img src="@/assets/images/logo.png" /> -->
                </div>
                <div class="w-full flex flex-col items-start gap-[24px]">
                  <!-- {{ isOffline }}
                  {{ isOnline }}
                  {{ isEdit }} -->
                  <div class="w-full grid gap-[24px]" v-if="isOffline == true && isEdit">
                    <div class="w-full flex flex-col items-start gap-[0px]">
                      <!-- {{ errors.c_prefix_id }}
                      {{ form.c_prefix_id }}
                      {{ form.c_first_name }} -->
                      <!-- {{ offLineData.detail }} -->
                      <SelectBoxComponent :inputId="'c_prefix'" :keyValue="'id'" :keyName="'name'"
                        :value="form.c_prefix_id" :options="allPrefix" :label="'คำนำหน้า'"
                        :placeholder="'เลือกคำนำหน้า'" :warningMessage="errors.c_prefix_id" :alertWarningMessage="true"
                        :disabled="offLineData.detail"
                        :allData="true" @update:modelValue="
                          (res) => {
                            form.c_prefix_id = res?.id ?? '';
                            form.c_prefix_name = res?.name ?? '';
                          }
                        " />
                    </div>
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <Input label="ชื่อ" placeholder="ชื่อ" v-model="form.c_first_name"
                        :warningMessage="errors.c_first_name"
                        :disabled="offLineData.detail" />
                    </div>

                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <Input label="นามสกุล" placeholder="นามสกุล" v-model="form.c_last_name"
                        :warningMessage="errors.c_last_name"
                        :disabled="offLineData.detail" />
                    </div>

                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <Input label="เบอร์โทรติดต่อ" placeholder="เบอร์โทรศัพท์" 
                      v-model="form.phone"
                        :warningMessage="errors.phone" 
                        @input="form.phone = $validateInputPhoneNum(form.phone)" />
                      
                      <span id="errphone" class="PC_Body2-R text-[#EB5554]">{{
                        errPhone
                      }}</span>
                    </div>

                    <!-- วันเกิด -->
                    <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-[14px]">
                      <DatePicker2 label="วันเกิด" :id="'birthDate1'" placeholder="เลือกวันเดือนปี"
                        :modelValue="form.birth_date" :warningMessage="errors.birth_date"
                        @update:modelValue="(date) => selectBirthDate(date)" />

                      <div class="flex items-end gap-[10px]">
                        <Input label="อายุ" placeholder="อายุ" v-model="form.age" :disabled="true" />
                        <span class="h-[35px]"> ปี </span>
                      </div>
                    </div>
                    <SelectBoxComponent :inputId="'c_gender'" :keyValue="'id'" :keyName="'name'"
                      :options="Selector.genderOptions" :value="form.c_gender" :label="'เพศ'" :placeholder="'เลือกเพศ'"
                      :warningMessage="errors.c_gender" @update:modelValue="
                        (res) => {
                          form.c_gender = res;
                        }
                      " />
                  </div>
                  <div v-else class="w-full flex flex-col gap-[24px]">
                    <div class="w-full flex flex-col items-start gap-[2px] mt-[20px]">
                      <div class="PC_Body2-R text-[#7C7379]">ชื่อผู้ประสบภัย</div>
                      <div class="PC_Body1-R text-[#1F1D1F]">
                        {{
                          userProfile?.name ||
                          form.c_prefix_name +
                          " " +
                          form?.c_first_name +
                          " " +
                          form?.c_last_name ||
                          "-"
                        }}
                      </div>
                    </div>

                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <div class="PC_Body2-R text-[#7C7379]">วันเกิด</div>
                      <div class="PC_Body1-R text-[#1F1D1F]">
                        {{
                          userProfile.birth_date || form.birth_date
                            ? `${$formatDate4(
                              userProfile.birth_date || form.birth_date
                            )} (${$CalAge(
                              userProfile.birth_date || form.birth_date
                            )} ปี)`
                            : "_"
                        }}
                      </div>
                    </div>
                    <!-- {{ userProfile?.gender }} -->
                    <!-- {{ form }} -->
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <div class="PC_Body2-R text-[#7C7379]">เพศ</div>
                      <div class="PC_Body1-R text-[#1F1D1F]">
                        {{
                          (() => {
                            const gender = userProfile?.gender ?? form?.c_gender;

                            if (gender == 1) return "ชาย";
                            if (gender == 2) return "หญิง";
                            return "-";
                          })()
                        }}
                      </div>
                    </div>
                  </div>

                  <div v-if="(!isEdit && userProfile?.gender == 2) ||
                    (!isEdit && form.pregnancy !== null && form.pregnancy !== undefined && form.c_gender == 2)"
                    class="w-full flex flex-col items-start gap-[2px]">
                    <div class="PC_Body2-R text-[#7C7379]">การตั้งครรภ์</div>
                    <div class="PC_Body1-R text-[#1F1D1F]">
                      <!-- {{ userProfile?.data }} -->
                      {{ form?.pregnancy == 0 ? "ไม่ตั้งครรภ์" : "ตั้งครรภ์" }}
                    </div>
                  </div>

                  <div v-if="isEdit" class="w-full flex flex-col items-start gap-[16px]">
                    <div class="flex gap-4 PC_Body2-R text-[#7C7379] flex-wrap">
                      <span class="title">ที่อยู่ปัจจุบัน</span>
                      <CheckBox v-if="isOffline == false" v-model="form.c_address_population" :value="1"
                        @update:modelValue="
                          (res) => {
                            setAddress(res);
                          }
                        " :label="'ข้อมูลเดียวกับที่อยู่ตามภูมิลำเนา'" />
                    </div>
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <!-- {{ form.p_province_code }} -->
                      <SelectBox :key="`province-${form.p_province_code}`" :searchable="true" id="provinceSelector"
                        placeholder="เลือกจังหวัด" class="w-full" optionToDisplay="provinceNameTh"
                        v-model="form.p_province_code" valueKey="provinceCode" :error="errors.p_province_code"
                        :options="provinceData.filter((p) => p.provinceCode === 57)" @change="
                          (res) => {
                            if (
                              form.c_address_population == 1 &&
                              res != userProfile.p_province_code
                            ) {
                              form.c_address_population = 0;
                            }
                            form.p_province_code = res;
                            form.p_district_code = '';
                            form.p_subdistrict_code = '';
                            form.p_postal_code = '';
                            form.p_geography_id = '';
                          }
                        " />

                      <!-- <SelectBox :searchable="true" :inputId="'provinceSelector'" valueKey="provinceCode"
                      optionToDisplay="provinceNameTh" :value="form.p_province_code" :placeholder="'เลือกจังหวัด'"
                      :warningMessage="errors.p_province_code" @change="(res) => {
                        if (form.c_address_population == 1 && res != userProfile.p_province_code) {
                          form.c_address_population = 0
                        }
                        form.p_province_code = res;
                        form.p_district_code = '';
                        form.p_subdistrict_code = '';
                        form.p_postal_code = '';
                        form.p_geography_id = '';
                      }
                      " /> -->
                    </div>
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <SelectBox :key="`district-${form.p_province_code}`" :searchable="true" id="districtSelector"
                        placeholder="เลือก เขต/อำเภอ" class="w-full" optionToDisplay="districtNameTh"
                        v-model="form.p_district_code" valueKey="districtCode" :error="errors.p_district_code"
                        :provinceCode="form.p_province_code" @change="
                          (res) => {
                            if (
                              form.c_address_population == 1 &&
                              res != userProfile.p_district_code
                            ) {
                              form.c_address_population = 0;
                            }
                            form.p_district_code = res;
                            form.p_subdistrict_code = '';
                            form.p_postal_code = '';
                            form.p_geography_id = '';
                          }
                        " />

                      <!-- 
                    <SelectBox :inputId="'districtSelectorP'" :keyValue="'districtCode'" :keyName="'districtNameTh'"
                      :value="form.p_district_code" :provinceCode="form.p_province_code"
                      :placeholder="'เลือก เขต/อำเภอ'" :warningMessage="errors.p_district_code" @change="(res) => {
                        if (form.c_address_population == 1 && res != userProfile.p_district_code) {
                          form.c_address_population = 0
                        }
                        form.p_district_code = res;
                        form.p_subdistrict_code = '';
                        form.p_postal_code = '';
                        form.p_geography_id = '';
                      }
                      " /> -->
                    </div>
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <SelectBox :key="`subdistrict-${form.p_district_code}`" :searchable="true"
                        id="subdistrictSelector" placeholder="เลือก แขวง/ตำบล" class="w-full"
                        optionToDisplay="subdistrictNameTh" v-model="form.p_subdistrict_code" valueKey="subdistrictCode"
                        :error="errors.p_subdistrict_code" :districtCode="form.p_district_code" @change="
                          (res) => {
                            if (res && res.subdistrictCode) {
                              if (
                                form.c_address_population == 1 &&
                                res.subdistrictCode != userProfile.p_subdistrict_code
                              ) {
                                form.c_address_population = 0;
                              }
                              form.p_subdistrict_code = res.subdistrictCode;
                              form.p_postal_code = res.postalCode;
                              form.p_geography_id = res.id;
                            }
                          }
                        " />

                      <!-- <SelectBox :inputId="'subDistrictSelectorP'" :keyValue="'subdistrictCode'"
                      :keyName="'subdistrictNameTh'" :value="form.p_subdistrict_code"
                      :districtCode="form.p_district_code" :placeholder="'เลือก แขวง/ตำบล'"
                      :warningMessage="errors.p_subdistrict_code" :allData="true" @change="(res) => {
                        if (res && res.subdistrictCode) {
                          if (form.c_address_population == 1 && res.subdistrictCode != userProfile.p_subdistrict_code) {
                            form.c_address_population = 0
                          }
                          form.p_subdistrict_code = res.subdistrictCode;
                          form.p_postal_code = res.postalCode;
                          form.p_geography_id = res.id;
                        }
                      }
                      " /> -->
                    </div>

                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <Input placeholder="รหัสไปรษณีย์" v-model="form.p_postal_code"
                        :warningMessage="errors.p_postal_code" :disabled="true" />
                    </div>
                    <div class="w-full flex flex-col items-start gap-[2px]">
                      <Input placeholder="บ้านเลขที่, หมู่ที่, ซอย, และข้อมูลอื่นๆ" v-model="form.p_address"
                        :warningMessage="errors.p_address" @input="handlePaddress()" />
                    </div>
                  </div>
                  <div v-else class="w-full flex flex-col items-start gap-[2px]">
                    <div class="PC_Body2-R text-[#7C7379]">ที่อยู่ปัจจุบัน</div>
                    <!-- {{ form }} -->
                    <div class="PC_Body1-R text-[#1F1D1F] pb-[25px]">
                      <template v-if="form && form.full_p_address_th">
                        {{ form.full_p_address_th }}
                      </template>

                      <template
                        v-else-if="userProfile && userProfile.full_p_address_th && isEdit == true && !assessment_id">
                        {{ userProfile.full_p_address_th }}
                      </template>

                      <template v-else> - </template>
                    </div>
                  </div>
                  <!-- check gender -->
                  <div v-if="
                    (isEdit && userProfile?.gender == 2) ||
                    (isEdit && form.c_gender == 2)
                  " class="w-full flex flex-col items-start gap-[16px]">
                    <div class="title">การตั้งครรภ์</div>
                    <Radio :id="'resources_choice1'" v-model="form.pregnancy" :name="'resources_choice1'" :value="0"
                      :label="'ไม่ตั้งครรภ์'" />
                    <Radio :id="'resources_choice1'" v-model="form.pregnancy" :name="'resources_choice1'" :value="1"
                      :label="'ตั้งครรภ์'" />
                  </div>
                  <!-- {{ form.pregnancy }} -->
                  <!-- {{ userProfile }} -->
                  <!-- {{ form.c_gender }} -->
                  


                  <!-- {{ form?.pregnancy }} -->
                </div>
              </div>
              <div v-if="isEdit" class="w-full border border-[#DFDCDD] border-dashed my-[25px]"></div>

              <!-- การให้นมบุตร -->
            <div class="flex flex-col ">
              
              
              <div v-if="isEdit || form.breastFeeding !== ''" class="page-keep w-full flex items-center gap-[10px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">การให้นมบุตร </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[16px]">
                <Radio v-model="form.breastFeeding" :value="0" :label="'ไม่ทราบ'" />
                <Radio v-model="form.breastFeeding" :value="1" :label="'ใช่'" />
                <Radio v-model="form.breastFeeding" :value="2" :label="'ไม่ใช่'" />
              </div>
              <div v-else-if="form.breastFeeding !== ''" class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ previewForm("breastFeeding", form.breastFeeding) }}
              </div>

              <!-- รอบวงศีรษะ (ซม.) -->
              <div class="my-[25px]">
              <div v-if="
                isEdit ||
                (form.headCircumference != '' &&
                  form.headCircumference != undefined &&
                  form.headCircumference != null)
              " class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F] pb-[16px]">รอบวงศีรษะ (ซม.)</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="ระบุตัวเลข" v-model="form.headCircumference" :disabled="!isEdit"
                  :inputType="'number'" :warningMessage="errors.headCircumference" />
              </div>
              <div v-else-if="
                form.headCircumference != '' &&
                form.headCircumference != undefined &&
                form.headCircumference != null
              " class="page-keep flex items-center">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ previewForm("headCircumference", form.headCircumference) }}
              </div>
              </div>
              

              <!-- ประวัติการรับวัคซีน โรคหัด -->
              <div v-if="isEdit || form.measlesVaccinationHistory !== ''"
                class="page-keep w-full flex items-center gap-[10px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F] ">ประวัติการรับวัคซีน โรคหัด
                </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[16px]">
                <Radio v-model="form.measlesVaccinationHistory" :value="0" :label="'ไม่ทราบ'" />
                <Radio v-model="form.measlesVaccinationHistory" :value="1" :label="'ใช่'" />
                <Radio v-model="form.measlesVaccinationHistory" :value="2" :label="'ไม่ใช่'" />
              </div>
              <div v-else-if="form.measlesVaccinationHistory !== ''" class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{
                  previewForm("measlesVaccinationHistory", form.measlesVaccinationHistory)
                }}
              </div>

              <!-- ประวัติการรับวัคซีน บาดทะยัก -->
              <div v-if="isEdit || form.historyOfTetanusVaccination !== ''"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F] pt-[25px] pb-[16px]">ประวัติการรับวัคซีน บาดทะยัก
                </span>
              </div>
              <div v-if="isEdit" class="flex flex-col items-start gap-[16px] mb-5">
                <Radio v-model="form.historyOfTetanusVaccination" :value="0" :label="'ไม่ทราบ'" />
                <Radio v-model="form.historyOfTetanusVaccination" :value="1" :label="'ใช่'" />
                <Radio v-model="form.historyOfTetanusVaccination" :value="2" :label="'ไม่ใช่'" />
              </div>
              <div v-else-if="form.historyOfTetanusVaccination !== ''" class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{
                  previewForm(
                    "historyOfTetanusVaccination",
                    form.historyOfTetanusVaccination
                  )
                }}
              </div>

              <!-- ประวัติการแพ้ -->
              <div v-if="isEdit || form.historyOfAllergies.value !== ''"
                class="page-keep w-full flex items-center gap-[10px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F] pt-[25px] pb-[16px]">ประวัติการแพ้</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Radio v-model="form.historyOfAllergies.value" :value="0" :label="'ไม่ทราบ'" />
                <Radio v-model="form.historyOfAllergies.value" :value="1" :label="'ไม่มี'" />
                <Radio v-model="form.historyOfAllergies.value" :value="2" :label="'มี'" />
                <div class="w-full flex flex-col gap-2 pl-[28px]">
                  <div class="flex items-center gap-4">
                    <span>ยา</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.historyOfAllergies.drug"
                      :warningMessage="errors.historyOfAllergies.drug" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>อาหาร</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.historyOfAllergies.food"
                      :warningMessage="errors.historyOfAllergies.food" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>อื่นๆ</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.historyOfAllergies.other"
                      :warningMessage="errors.historyOfAllergies.other" />
                  </div>
                </div>
                <span v-if="errors.historyOfAllergiesMessage" class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                  errors.historyOfAllergiesMessage }}</span>
              </div>
              <!-- <div v-else-if="form.historyOfAllergies.value !== ''" class="flex items-center">

              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div> {{
                previewForm('historyOfAllergies',
                  form.historyOfAllergies) }}

            </div> -->

              <div v-else-if="form.historyOfAllergies.value !== ''" class="page-keep flex flex-col gap-0">
                <div class="flex items-center fontSize14 pb-[16px]">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ previewForm("historyOfAllergies", form.historyOfAllergies) }}
                </div>
                <div v-if="form.historyOfAllergies.value == 2" class="w-full flex flex-col gap-[16px] pl-[28px] fontSize14">
                  <div v-if="form.historyOfAllergies.drug" class="">
                    ยา : {{ form.historyOfAllergies.drug }}
                  </div>
                  <div v-if="form.historyOfAllergies.food" class="">
                    อาหาร : {{ form.historyOfAllergies.food }}
                  </div>
                  <div v-if="form.historyOfAllergies.other" class="">
                    อื่นๆ : {{ form.historyOfAllergies.other }}
                  </div>
                </div>
              </div>

              <!-- ประวัติอดีต -->
              <div v-if="isEdit || form.pastHistory.value !== ''" class="page-keep w-full flex items-center gap-[10px] pt-[26px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">ประวัติอดีต</span>
              </div>
              <div v-if="isEdit" class="page-keep w-full flex flex-col items-start gap-[20px]">
                <Radio v-model="form.pastHistory.value" :value="0" :label="'ไม่ทราบ'" />
                <Radio v-model="form.pastHistory.value" :value="1" :label="'ไม่มี'" />
                <Radio v-model="form.pastHistory.value" :value="2" :label="'มี'" />
                <div class="w-full flex flex-col gap-2 pl-[28px]">
                  <div class="flex items-center gap-4">
                    <span>HT</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.pastHistory.ht"
                      :warningMessage="errors.pastHistory.ht" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>DM</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.pastHistory.dm"
                      :warningMessage="errors.pastHistory.dm" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>BA</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.pastHistory.ba"
                      :warningMessage="errors.pastHistory.ba" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>อื่นๆ</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.pastHistory.other"
                      :warningMessage="errors.pastHistory.other" />
                  </div>
                </div>
                <span v-if="errors.pastHistoryMessage" class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                  errors.pastHistoryMessage
                  }}</span>
              </div>
              <div v-else-if="form.pastHistory.value !== ''" class="page-keep flex flex-col gap-[16px]">
                <div class="page-keep flex items-center fontSize14">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ previewForm("pastHistory", form.pastHistory) }}
                </div>
                <div v-if="form.pastHistory.value == 2" class="w-full flex flex-col gap-[16px] pl-[28px] fontSize14">
                  <div v-if="form.pastHistory.ht" class="">
                    HT : {{ form.pastHistory.ht }}
                  </div>
                  <div v-if="form.pastHistory.dm" class="">
                    DM : {{ form.pastHistory.dm }}
                  </div>
                  <div v-if="form.pastHistory.ba" class="">
                    BA : {{ form.pastHistory.ba }}
                  </div>
                  <div v-if="form.pastHistory.other" class="">
                    อื่นๆ : {{ form.pastHistory.other }}
                  </div>
                </div>
              </div>

              <!-- ประวัติการใช้ยา -->
              <div v-if="isEdit || form.drugHistory.value !== ''" class="page-keep w-full flex items-center gap-[10px] pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">ประวัติการใช้ยา</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Radio v-model="form.drugHistory.value" :value="0" :label="'ไม่ทราบ'" />
                <!-- <Radio v-model="form.drugHistory" :value="1" :label="'HT'" />
              <Radio v-model="form.drugHistory" :value="2" :label="'DM'" />

              <Radio v-model="form.drugHistory" :value="3" :label="'BA'" /> -->
                <!-- <div class="w-full flex items-center gap-4">
                <Radio v-model="form.drugHistory" :value="4" :label="'อื่นๆ'" />
                <Input class="w-full" placeholder="ระบุ" v-model="form.drugHistoryOther"
                  :warningMessage="errors.drugHistoryOther" :disabled="form.drugHistory != 4" />
              </div> -->
                <Radio v-model="form.drugHistory.value" :value="1" :label="'ไม่มี'" />
                <Radio v-model="form.drugHistory.value" :value="2" :label="'มี'" />

                <div class="w-full flex flex-col gap-2 pl-[28px]">
                  <div class="flex items-center gap-4">
                    <span>HT</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.drugHistory.ht"
                      :warningMessage="errors.drugHistory.ht" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>DM</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.drugHistory.dm"
                      :warningMessage="errors.drugHistory.dm" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>BA</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.drugHistory.ba"
                      :warningMessage="errors.drugHistory.ba" />
                  </div>
                  <div class="flex items-center gap-4">
                    <span>อื่นๆ</span>
                    <Input class="w-full" placeholder="ระบุ" v-model="form.drugHistory.other"
                      :warningMessage="errors.drugHistory.other" />
                  </div>
                </div>
                <span v-if="errors.drugHistoryMessage" class="ml-[8px] PC_Body2-R text-[#EB5554]">{{
                  errors.drugHistoryMessage
                  }}</span>
              </div>

              <!-- <div v-else-if="form.drugHistory.value !== ''" class="flex items-center">

              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div> {{ previewForm('drugHistory',
                form.drugHistory) }}

            </div> -->
              <div v-else-if="form.drugHistory.value !== ''" class="flex flex-col gap-[16px]">
                <div class="page-keep flex items-center">
                  <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                  {{ previewForm("drugHistory", form.drugHistory) }}
                </div>
                <div v-if="form.drugHistory.value == 2" class="w-full flex flex-col gap-[16px] pl-[28px] fontSize14">
                  <div v-if="form.drugHistory.ht" class="">
                    HT : {{ form.drugHistory.ht }}
                  </div>
                  <div v-if="form.drugHistory.dm" class="">
                    DM : {{ form.drugHistory.dm }}
                  </div>
                  <div v-if="form.drugHistory.ba" class="">
                    BA : {{ form.drugHistory.ba }}
                  </div>
                  <div v-if="form.drugHistory.other" class="">
                    อื่นๆ : {{ form.drugHistory.other }}
                  </div>
                </div>
              </div>

              <!-- อาการสำคัญ (ซม.) -->
              <div v-if="
                isEdit ||
                (form.importantSymptoms != '' &&
                  form.importantSymptoms != undefined &&
                  form.importantSymptoms != null)
              " class="page-keep w-full flex items-center gap-[10px] pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F] ">อาการสำคัญ</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="ไม่บังคับ" v-model="form.importantSymptoms" :disabled="!isEdit"
                  :warningMessage="errors.importantSymptoms" />
              </div>
              <div v-else-if="
                form.importantSymptoms != '' &&
                form.importantSymptoms != undefined &&
                form.importantSymptoms != null
              " class="page-keep flex items-center">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ previewForm("importantSymptoms", form.importantSymptoms) }}
              </div>

              <!-- สัญญาณชีพ -->
              <div v-if="isEdit || hasAnyValue(form.vitalSigns)" class="w-full flex items-center gap-[10px] pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">สัญญาณชีพ</span>
              </div>
            </div>

              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px] mt-5">
                <Input :label="`อุณหภูมิ (องศาเซลเซียส)`" placeholder="ระบุตัวเลข" v-model="form.vitalSigns.temperature"
                  :inputType="'number'" :disabled="!isEdit" :warningMessage="errors.vitalSigns.temperature" />

                <label class="PC_Body1-SB text-[#1F1D1F]">ความดันโลหิต / มิลลิเมตรปรอท</label>
                <div class="w-full grid grid-cols-[1fr_48px_1fr] items-center">
                  <Input placeholder="ความดันโลหิต" :inputType="'number'" v-model="form.vitalSigns.bloodPressure"
                    :disabled="!isEdit" :warningMessage="errors.vitalSigns.bloodPressure" />
                  <span class="text-[#1F1D1F] text-center"> / </span>
                  <Input placeholder="มิลลิเมตรปรอท" :inputType="'number'"
                    v-model="form.vitalSigns.bloodPressureMillimeterOfMercury" :disabled="!isEdit"
                    :warningMessage="errors.vitalSigns.bloodPressureMillimeterOfMercury" />
                </div>

                <Input :label="`ชีพจร (ครั้งต่อนาที)`" placeholder="ระบุตัวเลข" v-model="form.vitalSigns.pulse"
                  :inputType="'number'" :disabled="!isEdit" :warningMessage="errors.vitalSigns.pulse" />
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px] mt-5">
                <Input :label="`อัตราหายใจ (ครั้งต่อนาที)`" placeholder="ระบุตัวเลข"
                  v-model="form.vitalSigns.respiratoryRate" :inputType="'number'" :disabled="!isEdit"
                  :warningMessage="errors.vitalSigns.respiratoryRate" />
                <Input :label="`น้ำหนัก (กิโลกรัม)`" placeholder="ระบุตัวเลข" v-model="form.vitalSigns.weight"
                  :inputType="'number'" :disabled="!isEdit" :warningMessage="errors.vitalSigns.weight" />
                <Input :label="`ส่วนสูง (เซนติเมตร)`" placeholder="ระบุตัวเลข" v-model="form.vitalSigns.height"
                  :inputType="'number'" :disabled="!isEdit" :warningMessage="errors.vitalSigns.height" />
              </div>
              <div v-if="!isEdit" class="flex flex-col items-start gap-[16px]">
                <div v-if="form.vitalSigns.temperature" class="page-keep flex flex-col gap-[16px]">
                  <div class="PC_Body1-SB text-[#1F1D1F]">อุณหภูมิ (องศาเซลเซียส)</div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{ form.vitalSigns.temperature }}
                  </div>
                </div>
                <div v-if="form.vitalSigns.bloodPressure" class="page-keep flex flex-col gap-2">
                  <div class="PC_Body1-SB text-[#1F1D1F]">
                    ความดันโลหิต / มิลลิเมตรปรอท
                  </div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{
                      `${form.vitalSigns.bloodPressure
                        ? form.vitalSigns.bloodPressure
                        : "-"
                      } /
                    ${form.vitalSigns.bloodPressureMillimeterOfMercury
                        ? form.vitalSigns.bloodPressureMillimeterOfMercury
                        : "-"
                      } `
                    }}
                  </div>
                </div>
                <div v-if="form.vitalSigns.pulse" class="page-keep flex flex-col gap-2">
                  <div class="PC_Body1-SB text-[#1F1D1F]">ชีพจร (ครั้งต่อนาที)</div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{ form.vitalSigns.pulse }}
                  </div>
                </div>

                <div v-if="form.vitalSigns.respiratoryRate" class="page-keep flex flex-col gap-2">
                  <div class="PC_Body1-SB text-[#1F1D1F]">อัตราหายใจ (ครั้งต่อนาที)</div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{ form.vitalSigns.respiratoryRate }}
                  </div>
                </div>
                <div v-if="form.vitalSigns.weight" class="page-keep flex flex-col gap-2">
                  <div class="PC_Body1-SB text-[#1F1D1F]">น้ำหนัก (กิโลกรัม)</div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{ form.vitalSigns.weight }}
                  </div>
                </div>
                <div v-if="form.vitalSigns.height" class="page-keep flex flex-col gap-2">
                  <div class="PC_Body1-SB text-[#1F1D1F]">ส่วนสูง (เซนติเมตร)</div>
                  <div class="PC_Body2-R text-[#1F1D1F] flex items-center">
                    <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                    {{ form.vitalSigns.height }}
                  </div>
                </div>
              </div>

              <!-- ประวัติการเจ็บป่วยปัจจุบัน -->
              <div v-if="
                isEdit ||
                (form.historyOfCurrentIllness != '' &&
                  form.historyOfCurrentIllness != undefined &&
                  form.historyOfCurrentIllness != null)
              " class="page-keep w-full flex items-center gap-[10px] pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">ประวัติการเจ็บป่วยปัจจุบัน</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="กรอกข้อมูล" v-model="form.historyOfCurrentIllness" :disabled="!isEdit"
                  :warningMessage="errors.historyOfCurrentIllness" />
              </div>
              <div v-else-if="
                form.historyOfCurrentIllness != '' &&
                form.historyOfCurrentIllness != undefined &&
                form.historyOfCurrentIllness != null
              " class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ previewForm("historyOfCurrentIllness", form.historyOfCurrentIllness) }}
              </div>

              <!-- การวินิจฉัย -->
              <div v-if="
                isEdit ||
                (form.diagnosis != '' &&
                  form.diagnosis != undefined &&
                  form.diagnosis != null)
              " class="page-keep w-full flex items-center gap-[10px] pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">การวินิจฉัย</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="กรอกข้อมูล" v-model="form.diagnosis" :disabled="!isEdit"
                  :warningMessage="errors.diagnosis" />
              </div>
              <div v-else-if="
                form.diagnosis != '' &&
                form.diagnosis != undefined &&
                form.diagnosis != null
              " class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{ previewForm("diagnosis", form.diagnosis) }}
              </div>

              <!-- ยา ชื่อยา/ขนาดวิธีการใช้ -->
              <div v-if="
                isEdit ||
                (form.drugNameDrugSizeHowToUse != '' &&
                  form.drugNameDrugSizeHowToUse != undefined &&
                  form.drugNameDrugSizeHowToUse != null)
              " class="page-keep w-full flex items-center gap-[10px] fontSize14 pt-[25px] pb-[16px]">
                <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
                <span class="PC_Body1-SB text-[#1F1D1F]">ยา ชื่อยา/ขนาดวิธีการใช้</span>
              </div>
              <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
                <Input placeholder="กรอกข้อมูล" v-model="form.drugNameDrugSizeHowToUse" :disabled="!isEdit"
                  :warningMessage="errors.drugNameDrugSizeHowToUse" />
              </div>
              <div v-else-if="
                form.drugNameDrugSizeHowToUse != '' &&
                form.drugNameDrugSizeHowToUse != undefined &&
                form.drugNameDrugSizeHowToUse != null
              " class="page-keep flex items-center fontSize14">
                <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
                {{
                  previewForm("drugNameDrugSizeHowToUse", form.drugNameDrugSizeHowToUse)
                }}
              </div>

              <!-- บันทึกเพิ่มเติม -->
              <!-- <div
              v-if="isEdit || (form.additionalNotes != '' && form.additionalNotes != undefined && form.additionalNotes != null)"
              class=" w-full flex items-center gap-[10px]">
              <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
              <span class="PC_Body1-SB text-[#1F1D1F]">บันทึกเพิ่มเติม</span>
            </div>
            <div v-if="isEdit" class="w-full flex flex-col items-start gap-[20px]">
              <Input placeholder="ไม่บังคับ" v-model="form.additionalNotes" :disabled="!isEdit"
                :warningMessage="errors.additionalNotes" />
            </div>
            <div
              v-else-if="form.additionalNotes != '' && form.additionalNotes != undefined && form.additionalNotes != null"
              class="flex items-center">
              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div> {{
                previewForm('additionalNotes',
                  form.additionalNotes) }}

            </div> -->
            </div>
            <!-- info -->
          </div>
        </div>
        <div v-if="isEdit || (isEdit && isOnline == false)" class="w-full flex justify-end items-center gap-[10px]">
          <ButtonComponent :label="'ยกเลิก'" :bClass="'btn_shadow--cancel'" @clicked="cancelAssessment" />
          <ButtonComponent :label="'บันทึก'" :bClass="'btn_shadow--save'" :disabled="!canSave"
            @clicked="takeAssessment" />
        </div>
      </div>
      <LogHistoryAssessmentModal ref="LogHistoryAssessmentModalRef" />
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, watch, computed, nextTick } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import html2pdf from "html2pdf.js";
import axios from "axios";
import fs from "fs";
import logo from '@/assets/images/User.png'

// import {
//   addOfflineAssessment,
//   getOfflineAssessments,
//   updateOfflineAssessment,
// } from "@/components/Utilities/javascripts/offlineAssessment";
import {
  getOfflineAssessments,
  addOfflineAssessment,
  updateOfflineAssessment,
  deleteOfflineAssessment,
  clearOfflineAssessments,
} from "@/components/Utilities/javascripts/offlineAssessmentStorage";

import { useOnlineStatus } from "@/composables/useOnlineStatus";
import { useRoute, useRouter } from "vue-router";
import { usePopulationStore } from "@/pinia/population";
import { inject } from "vue";
import provinceData from "@/assets/json/provinces.json";
import { usePrefixStore } from "@/pinia/prefix";
import { storeToRefs } from "pinia";
import { Selector } from "@/components/Utilities/javascripts/constants";
const { $CalAge } = useGlobals();
import { useAuthStore } from "@/pinia/authStore";

// === ใช้เมื่อต้องประกอบที่อยู่แบบ type3 ===
import { resolveAddress } from "@/components/Utilities/javascripts/addressResolver";

const pdfRef = ref(null);
const route = useRoute();
const router = useRouter();
const prefixStore = usePrefixStore();
const { allPrefix } = storeToRefs(prefixStore);
const { isOnline, checkNow } = useOnlineStatus();
const { $buildFormData } = useGlobals();
const userPopulation = usePopulationStore();
const statusModal = inject("statusModal");
const LogHistoryAssessmentModalRef = ref(null);
const canSave = ref(false); // true = ผ่าน validate → ปุ่ม save กดได้

const profileData = ref({});
const errPhone = ref(null);

const auth = useAuthStore();
const { userData } = storeToRefs(auth);

function makeEmptyErrors() {
  return {
    // ฟิลด์พื้นฐาน
    c_prefix_id: "",
    c_first_name: "",
    c_last_name: "",
    phone: "",

    datetime: "",
    p_province_code: "",
    p_district_code: "",
    p_subdistrict_code: "",
    p_postal_code: "",
    p_address: "",

    // type2 blocks
    illness: {
      trauma: "",
      infectious: "",
      urgent: "",
      otherMajor: "",
      extraNote: "",
      message: "",
    },
    care: { procedures: "", outcomes: "", outcomesMessage: "" },
    context: {
      relationships: "",
      prevention: "",
      extraNote: "",
      relationshipsMessage: "",
    },

    // vitalSigns
    vitalSigns: {
      temperature: "",
      bloodPressure: "",
      bloodPressureMillimeterOfMercury: "",
      pulse: "",
      respiratoryRate: "",
      weight: "",
      height: "",
    },

    // สกีมาใหม่ (ต้องมีคีย์ย่อยให้ template อ้างได้)
    historyOfAllergies: { value: "", drug: "", food: "", other: "" },
    pastHistory: { value: "", ht: "", dm: "", ba: "", other: "" },
    drugHistory: { value: "", ht: "", dm: "", ba: "", other: "" },

    // ข้อความรวมของแต่ละบล็อก
    historyOfAllergiesMessage: "",
    pastHistoryMessage: "",
    drugHistoryMessage: "",
  };
}
/** ====== STATE หลักของฟอร์ม ====== */
let input = {
  datetime: "",
  pregnancy: 0,
  max_capacity: "",
  population_id: "",
  type: 2, // <= เปลี่ยนเป็น 2 หรือ 3 เพื่อใช้โหมดฟอร์ม
  c_prefix_id: "",
  c_prefix_name: "",
  c_first_name: "",
  c_last_name: "",
  birth_date: "",
  age: "",
  gender: "",
  phone: "",
  c_nick_name: "",
  c_gender: "",
  c_address_population: 1,

  p_province_code: "",
  p_district_code: "",
  p_subdistrict_code: "",
  p_postal_code: "",
  p_address: "",
  p_geography_id: "",
  full_p_address_th: "",
  full_p_address_en: "",

  // ===== type2 -----------------------
  illness: {
    //  การเจ็บป่วย
    trauma: [],
    infectious: [],
    urgent: [],
    otherMajor: [],
    extraNote: "",
  },
  care: {
    //  จัดการและผลการรักษา
    procedures: [],
    outcomes: [],
  },
  context: {
    //  บริบท
    relationships: [],
    prevention: [],
    extraNote: "",
  },

  // ===== type3 -----------------------
  breastFeeding: 0,
  headCircumference: "",
  measlesVaccinationHistory: 0,
  historyOfTetanusVaccination: 0,

  historyOfAllergies: {
    value: 0,
    drug: "",
    food: "",
    other: "",
  },

  pastHistory: {
    value: 0,
    ht: "",
    dm: "",
    ba: "",
    other: "",
  },

  drugHistory: {
    value: 0,
    ht: "",
    dm: "",
    ba: "",
    other: "",
  },

  importantSymptoms: "",
  vitalSigns: {
    temperature: "",
    bloodPressure: "",
    bloodPressureMillimeterOfMercury: "",
    pulse: "",
    respiratoryRate: "",
    weight: "",
    height: "",
  },
  historyOfCurrentIllness: "",
  diagnosis: "",
  drugNameDrugSizeHowToUse: "",
  additionalNotes: "",
};

const submitted = ref(false);

const form = reactive({
  ...input,
  datetime: new Date(),
  illness: { ...input.illness },
  care: { ...input.care, outcomesMessage: "" },
  context: { ...input.context, relationshipsMessage: "" },
  vitalSigns: { ...input.vitalSigns },
  historyOfAllergies: { ...input.historyOfAllergies },
  pastHistory: { ...input.pastHistory },
  drugHistory: { ...input.drugHistory },
});
// const errors = ref({
//   ...input,
//   illness: { ...input.illness, message: '' },
//   care: { ...input.care },
//   context: { ...input.context },
//   vitalSigns: { ...input.vitalSigns },
//   historyOfAllergies: { ...input.historyOfAllergies },
//   pastHistory: { ...input.pastHistory },
//   drugHistory: { ...input.drugHistory },
//   historyOfAllergiesMessage: '',
//   pastHistoryMessage: '',
//   drugHistoryMessage: '',

// });
const errors = ref(makeEmptyErrors());
const created_name = ref("");

const item = ref({});
const isEdit = ref(false);
const lastLoaded = ref(null);
const isOffline = ref(false);

const assessment_id = ref("");
const assessment_count = ref("");
const population_id = ref("");
const image = ref("");
const imageSize = ref("");

const userProfile = ref({});
const assessmentData = ref({});
const keys = [
  "p_address",
  "p_geography_id",
  "p_province_code",
  "p_district_code",
  "p_subdistrict_code",
  "p_postal_code",
  "full_p_address_th",
  "full_p_address_en",
];

/* ====== ตัวเลือก type2 ====== */
const traumaOptions = [
  {
    value: "severeHeadSpineInjury",
    label: "บาดเจ็บบริเวณศีรษะ/กระดูกสันหลังอย่างรุนแรง",
  },
  { value: "severeTorsoInjury", label: "บาดเจ็บบริเวณลำตัวอย่างรุนแรง" },
  { value: "limbInjury", label: "บาดเจ็บบริเวณส่วนปลายแขนขา" },
  { value: "moderateInjury", label: "บาดเจ็บปานกลาง" },
  { value: "minorInjury", label: "บาดเจ็บเล็กน้อย" },
];
const infectiousOptions = [
  { value: "acuteRespiratoryInfection", label: "การติดเชื้อทางเดินหายใจเฉียบพลัน" },
  { value: "acuteDiarrhea", label: "ท้องเสียเฉียบพลัน" },
  { value: "acuteBloodyDiarrhea", label: "ท้องเสียเป็นเลือดเฉียบพลัน" },
  { value: "acuteJaundice", label: "โรคดีซ่านเฉียบพลัน" },
  { value: "suspectedMeasles", label: "สงสัยเป็นโรคหัด (Measles)" },
  { value: "suspectedMeningitis", label: "สงสัยเยื่อหุ้มสมองอักเสบ" },
  { value: "suspectedTetanus", label: "สงสัยบาดทะยัก" },
  { value: "acuteParalysis", label: "อัมพาตเฉียบพลัน" },
  { value: "acuteDengue", label: "ไข้เลือดออกเฉียบพลัน" },
  { value: "feverUnknownCause", label: "ไข้ไม่ทราบสาเหตุ" },
];
const urgentOptions = [
  {
    value: "surgicalEmergencyNonTrauma",
    label: "โรคทางศัลยกรรมฉุกเฉิน (ไม่ใช่การบาดเจ็บ)",
  },
  {
    value: "medicalEmergencyNonInfectious",
    label: "โรคทางอายุรกรรมฉุกเฉิน (ไม่ติดเชื้อ)",
  },
];
const otherMajorOptions = [
  { value: "dermatologicDisease", label: "โรคผิวหนัง" },
  { value: "acuteMentalHealth", label: "ปัญหาสุขภาพจิตเฉียบพลัน" },
  { value: "obstetricComplication", label: "ภาวะแทรกซ้อนทางสูติกรรม" },
  { value: "acuteSevereMalnutrition", label: "ภาวะทุพโภชนาการเฉียบพลันรุนแรง (SAM) *" },
  { value: "otherDiagnosis", label: "การวินิจฉัยอื่น ๆ ที่ไม่ได้ระบุไว้ข้างต้น " },
];
const procedureOptions = [
  {
    value: "majorProcedureExcludingMd53",
    label: "หัตถการหลัก (Major procedure) (ไม่รวม MDS31)",
  },
  { value: "limbAmputation", label: "การตัดแขนขาไม่รวมนิ้ว *" },
  { value: "minorSurgery", label: "การผ่าตัดเล็ก" },
  { value: "normalVaginalDelivery", label: "การคลอดปกติผ่านช่องคลอด (NVD)" },
  { value: "cesareanDelivery", label: "การผ่าคลอด" },
  { value: "otherObstetricProcedure", label: "สูติศาสตร์ อื่นๆ" },
];
const outcomeOptions = [
  {
    value: "dischargedNoFollowup",
    label: "ออกจากโรงพยาบาลโดยไม่มีการติดตามการรักษาพยาบาล",
  },
  { value: "dischargedWithFollowup", label: "ออกจากโรงพยาบาลพร้อมติดตามการรักษา" },
  { value: "refusedTreatment", label: "การปฏิเสธการรักษา" },
  { value: "referredToOtherFacility", label: "ส่งต่อไปยังสถานพยาบาลอื่น" },
  { value: "admittedInpatient", label: "รับไว้เป็นผู้ป่วยใน" },
  { value: "diedOnArrival", label: "เสียชีวิตตั้งแต่มาถึง" },
  { value: "diedInFacility", label: "เสียชีวิตภายในสถานพยาบาล *" },
  { value: "needsLongTermRehabilitation", label: "ต้องการการฟื้นฟูระยะยาว *" },
];
const relationshipOptions = [
  { value: "directlyRelatedToDisaster", label: "เกี่ยวข้องกับสาธารณภัยครั้งนี้โดยตรง" },
  {
    value: "indirectlyRelatedToDisaster",
    label: "เกี่ยวข้องกับสาธารณภัยครั้งนี้ทางอ้อม",
  },
  { value: "notRelatedToDisaster", label: "ไม่เกี่ยวข้องกับสาธารณภัยครั้งนี้" },
];
const preventionOptions = [
  { value: "vulnerableChild", label: "เด็กเปราะบาง *" },
  { value: "vulnerableAdult", label: "ผู้ใหญ่เปราะบาง *" },
  { value: "sexualGenderBasedViolence", label: "ความรุนแรงทางเพศทางเพศ (SGBV) *" },
  { value: "nonSexualViolence", label: "ความรุนแรง (ไม่ใช่ SGBV) *" },
];

const isURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const pdfUrl = ref({});
const imageUrl = ref({});
const offLineData = ref({});

/* ===== Snapshot (ขยายให้ครอบคลุม type2+type3) ===== */
const pristineForm = ref(null);
const exportPlainForm = () => ({
  // ร่วม
  datetime: form.datetime ? new Date(form.datetime) : "",
  pregnancy: form.pregnancy,
  max_capacity: form.max_capacity,
  population_id: form.population_id,
  type: form.type,

  // header ชื่อ-ที่อยู่
  c_prefix_id: form.c_prefix_id,
  c_prefix_name: form.c_prefix_name,
  c_first_name: form.c_first_name,
  c_last_name: form.c_last_name,
  c_nick_name: form.c_nick_name,
  c_gender: form.c_gender,
  c_address_population: form.c_address_population,

  p_province_code: form.p_province_code,
  p_district_code: form.p_district_code,
  p_subdistrict_code: form.p_subdistrict_code,
  p_postal_code: form.p_postal_code,
  p_address: form.p_address,
  p_geography_id: form.p_geography_id,
  full_p_address_th: form.full_p_address_th,
  full_p_address_en: form.full_p_address_en,

  // type2
  illness: {
    trauma: [...(form.illness?.trauma ?? [])],
    infectious: [...(form.illness?.infectious ?? [])],
    urgent: [...(form.illness?.urgent ?? [])],
    otherMajor: [...(form.illness?.otherMajor ?? [])],
    extraNote: form.illness?.extraNote ?? "",
  },
  care: {
    procedures: [...(form.care?.procedures ?? [])],
    outcomes: [...(form.care?.outcomes ?? [])],
  },
  context: {
    relationships: [...(form.context?.relationships ?? [])],
    prevention: [...(form.context?.prevention ?? [])],
    extraNote: form.context?.extraNote ?? "",
  },

  // type3 (สกีมาใหม่เป็นอ็อบเจ็กต์)
  breastFeeding: form.breastFeeding,
  headCircumference: form.headCircumference,
  measlesVaccinationHistory: form.measlesVaccinationHistory,
  historyOfTetanusVaccination: form.historyOfTetanusVaccination,

  historyOfAllergies: { ...form.historyOfAllergies },
  pastHistory: { ...form.pastHistory },
  drugHistory: { ...form.drugHistory },

  importantSymptoms: form.importantSymptoms,
  vitalSigns: {
    temperature: form.vitalSigns.temperature,
    bloodPressure: form.vitalSigns.bloodPressure,
    bloodPressureMillimeterOfMercury: form.vitalSigns.bloodPressureMillimeterOfMercury,
    pulse: form.vitalSigns.pulse,
    respiratoryRate: form.vitalSigns.respiratoryRate,
    weight: form.vitalSigns.weight,
    height: form.vitalSigns.height,
  },
  historyOfCurrentIllness: form.historyOfCurrentIllness,
  diagnosis: form.diagnosis,
  drugNameDrugSizeHowToUse: form.drugNameDrugSizeHowToUse,
  additionalNotes: form.additionalNotes,
});
const takeSnapshot = () => {
  pristineForm.value = exportPlainForm();
};
const restoreFromSnapshot = () => {
  if (!pristineForm.value) return;
  const s = pristineForm.value;

  // ร่วม
  form.datetime = s.datetime ? new Date(s.datetime) : "";
  form.pregnancy = s.pregnancy;
  form.max_capacity = s.max_capacity;
  form.population_id = s.population_id;
  form.type = s.type;

  // header
  form.c_prefix_id = s.c_prefix_id;
  form.c_prefix_name = s.c_prefix_name;
  form.c_first_name = s.c_first_name;
  form.c_last_name = s.c_last_name;
  form.c_nick_name = s.c_nick_name;
  form.c_gender = s.c_gender;
  form.c_address_population = s.c_address_population;

  form.p_province_code = s.p_province_code;
  form.p_district_code = s.p_district_code;
  form.p_subdistrict_code = s.p_subdistrict_code;
  form.p_postal_code = s.p_postal_code;
  form.p_address = s.p_address;
  form.p_geography_id = s.p_geography_id;
  form.full_p_address_th = s.full_p_address_th;
  form.full_p_address_en = s.full_p_address_en;

  // type2
  form.illness.trauma = [...(s.illness?.trauma ?? [])];
  form.illness.infectious = [...(s.illness?.infectious ?? [])];
  form.illness.urgent = [...(s.illness?.urgent ?? [])];
  form.illness.otherMajor = [...(s.illness?.otherMajor ?? [])];
  form.illness.extraNote = s.illness?.extraNote ?? "";
  form.care.procedures = [...(s.care?.procedures ?? [])];
  form.care.outcomes = [...(s.care?.outcomes ?? [])];
  form.context.relationships = [...(s.context?.relationships ?? [])];
  form.context.prevention = [...(s.context?.prevention ?? [])];
  form.context.extraNote = s.context?.extraNote ?? "";

  // type3 (สกีมาใหม่)
  form.breastFeeding = s.breastFeeding;
  form.headCircumference = s.headCircumference;
  form.measlesVaccinationHistory = s.measlesVaccinationHistory;
  form.historyOfTetanusVaccination = s.historyOfTetanusVaccination;

  form.historyOfAllergies = {
    ...(s.historyOfAllergies || { value: 0, drug: "", food: "", other: "" }),
  };
  form.pastHistory = {
    ...(s.pastHistory || { value: 0, ht: "", dm: "", ba: "", other: "" }),
  };
  form.drugHistory = {
    ...(s.drugHistory || { value: 0, ht: "", dm: "", ba: "", other: "" }),
  };

  form.importantSymptoms = s.importantSymptoms;
  form.vitalSigns = { ...s.vitalSigns }; // คง reactive
  form.historyOfCurrentIllness = s.historyOfCurrentIllness;
  form.diagnosis = s.diagnosis;
  form.drugNameDrugSizeHowToUse = s.drugNameDrugSizeHowToUse;
  form.additionalNotes = s.additionalNotes;
};

function computeErrorsSnapshot() {
  const e = makeEmptyErrors(); // << โครงครบ ปลอดภัยกับ template
  let ok = true;

  if (isOnline.value == false) {
    if (!validateRequiredForm(form)) {
      ok = false;
    }
  }

  // datetime
  if (!form.datetime || isNaN(new Date(form.datetime).getTime())) {
    ok = false;
    e.datetime = "โปรดเลือกวันที่ประเมิน";
  }

  // illness เลือกอย่างน้อย 1 หมวด
  const { trauma = [], infectious = [], urgent = [], otherMajor = [] } =
    form.illness || {};
  if (!trauma.length && !infectious.length && !urgent.length && !otherMajor.length) {
    ok = false;
    e.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }

  // care/context
  if (!Array.isArray(form.care?.outcomes) || form.care.outcomes.length === 0) {
    ok = false;
    e.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }
  if (
    !Array.isArray(form.context?.relationships) ||
    form.context.relationships.length === 0
  ) {
    ok = false;
    e.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }

  // history blocks (value === 2 = มี ต้องใส่รายละเอียด)
  if (Number(form.historyOfAllergies?.value) === 2) {
    const filled = ["drug", "food", "other"].some((k) =>
      (form.historyOfAllergies?.[k] || "").trim()
    );
    if (!filled) {
      ok = false;
      e.historyOfAllergiesMessage = "กรุณาระบุรายละเอียดการแพ้ (ยา/อาหาร/อื่นๆ)";
    }
  }
  if (Number(form.pastHistory?.value) === 2) {
    const filled = ["ht", "dm", "ba", "other"].some((k) =>
      (form.pastHistory?.[k] || "").trim()
    );
    if (!filled) {
      ok = false;
      e.pastHistoryMessage = "กรุณาระบุรายละเอียดประวัติ (HT/DM/BA/อื่นๆ)";
    }
  }
  if (Number(form.drugHistory?.value) === 2) {
    const filled = ["ht", "dm", "ba", "other"].some((k) =>
      (form.drugHistory?.[k] || "").trim()
    );
    if (!filled) {
      ok = false;
      e.drugHistoryMessage = "กรุณาระบุรายละเอียดการใช้ยา (HT/DM/BA/อื่นๆ)";
    }
  }

  // address
  // const isEmpty = (v) =>
  //   v === '' || v === null || v === undefined ||
  //   (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0)

  // if (isEmpty(form.c_prefix_id)) { ok = false; e.c_prefix_id = 'โปรดเลือกคำนำหน้า' }
  // if (isEmpty(form.c_first_name)) { ok = false; e.c_first_name = 'โปรดกรอกชื่อ' }
  // if (isEmpty(form.c_last_name)) { ok = false; e.c_last_name = 'โปรดกรอกนามสกุล' }
  // if (isEmpty(form.c_gender)) { ok = false; e.c_gender = 'โปรดระบุเพศ' }

  // if (isEmpty(form.p_province_code)) { ok = false; e.p_province_code = 'โปรดเลือกจังหวัด' }
  // if (isEmpty(form.p_district_code)) { ok = false; e.p_district_code = 'โปรดเลือกเขต/อำเภอ' }
  // if (isEmpty(form.p_subdistrict_code)) { ok = false; e.p_subdistrict_code = 'โปรดเลือกแขวง/ตำบล' }
  // if (isEmpty(form.p_postal_code)) {
  //   ok = false; e.p_postal_code = 'โปรดระบุรหัสไปรษณีย์'
  // } else if (!/^\d{5}$/.test(String(form.p_postal_code))) {
  //   ok = false; e.p_postal_code = 'รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก'
  // }
  // if (isEmpty(form.p_address)) { ok = false; e.p_address = 'โปรดกรอกที่อยู่' }

  return { ok, errors: e };
}

// === Auto-set value = 2 เมื่อมีการกรอกรายละเอียดอย่างน้อย 1 ช่อง ===
// const anyFilled = (obj, keys) =>
//   keys.some(k => String(obj?.[k] ?? '').trim().length > 0)
function anyFilled(obj, keys) {
  return keys.some((k) => String(obj?.[k] ?? "").trim().length > 0);
}
// === Auto logic for historyOfAllergies ===
watch(
  () => [
    form.historyOfAllergies.drug,
    form.historyOfAllergies.food,
    form.historyOfAllergies.other,
  ],
  () => {
    if (anyFilled(form.historyOfAllergies, ["drug", "food", "other"])) {
      form.historyOfAllergies.value = 2;
    }
  }
);

// ถ้า value ไม่ใช่ 2 → เคลียร์ค่า drug, food, other
watch(
  () => form.historyOfAllergies.value,
  (val) => {
    if (val !== 2) {
      form.historyOfAllergies.drug = "";
      form.historyOfAllergies.food = "";
      form.historyOfAllergies.other = "";
    }
  }
);

// === Auto logic for pastHistory ===
watch(
  () => [
    form.pastHistory.ht,
    form.pastHistory.dm,
    form.pastHistory.ba,
    form.pastHistory.other,
  ],
  () => {
    if (anyFilled(form.pastHistory, ["ht", "dm", "ba", "other"])) {
      form.pastHistory.value = 2;
    }
  }
);

watch(
  () => form.pastHistory.value,
  (val) => {
    if (val !== 2) {
      form.pastHistory.ht = "";
      form.pastHistory.dm = "";
      form.pastHistory.ba = "";
      form.pastHistory.other = "";
    }
  }
);

// === Auto logic for drugHistory ===
watch(
  () => [
    form.drugHistory.ht,
    form.drugHistory.dm,
    form.drugHistory.ba,
    form.drugHistory.other,
  ],
  () => {
    if (anyFilled(form.drugHistory, ["ht", "dm", "ba", "other"])) {
      form.drugHistory.value = 2;
    }
  }
);

watch(
  () => form.drugHistory.value,
  (val) => {
    if (val !== 2) {
      form.drugHistory.ht = "";
      form.drugHistory.dm = "";
      form.drugHistory.ba = "";
      form.drugHistory.other = "";
    }
  }
);
// allergies
watch(
  () => [
    form.historyOfAllergies.drug,
    form.historyOfAllergies.food,
    form.historyOfAllergies.other,
  ],
  () => {
    if (
      anyFilled(form.historyOfAllergies, ["drug", "food", "other"]) &&
      form.historyOfAllergies.value !== 2
    ) {
      form.historyOfAllergies.value = 2;
    }
  }
);
watch(
  () => form.historyOfAllergies.value,
  (v) => {
    if (v !== 2) {
      form.historyOfAllergies.drug = "";
      form.historyOfAllergies.food = "";
      form.historyOfAllergies.other = "";
    }
  }
);

// past
watch(
  () => [
    form.pastHistory.ht,
    form.pastHistory.dm,
    form.pastHistory.ba,
    form.pastHistory.other,
  ],
  () => {
    if (
      anyFilled(form.pastHistory, ["ht", "dm", "ba", "other"]) &&
      form.pastHistory.value !== 2
    ) {
      form.pastHistory.value = 2;
    }
  }
);
watch(
  () => form.pastHistory.value,
  (v) => {
    if (v !== 2) {
      form.pastHistory.ht = "";
      form.pastHistory.dm = "";
      form.pastHistory.ba = "";
      form.pastHistory.other = "";
    }
  }
);

// drug
watch(
  () => [
    form.drugHistory.ht,
    form.drugHistory.dm,
    form.drugHistory.ba,
    form.drugHistory.other,
  ],
  () => {
    if (
      anyFilled(form.drugHistory, ["ht", "dm", "ba", "other"]) &&
      form.drugHistory.value !== 2
    ) {
      form.drugHistory.value = 2;
    }
  }
);
watch(
  () => form.drugHistory.value,
  (v) => {
    if (v !== 2) {
      form.drugHistory.ht = "";
      form.drugHistory.dm = "";
      form.drugHistory.ba = "";
      form.drugHistory.other = "";
    }
  }
);
/* ===== Utils ที่ใช้ร่วม (จาก form3) ===== */
const norm = (v) => {
  if (v == null) return "";
  if (typeof v === "number") return String(v);
  return String(v).trim();
};
const isDirty = computed(() =>
  keys.some((k) => norm(form[k]) !== norm(userProfile.value?.[k]))
);
const openLog = () => {
  LogHistoryAssessmentModalRef.value.openModal(assessment_id.value);
};
const changeMode = (editing) => {
  if (editing) takeSnapshot();
  isEdit.value = editing;
};
const formatDateYMD = (d) => {
  try {
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch {
    return "";
  }
};
const isNum = (v) => v !== "" && v !== null && v !== undefined && !isNaN(Number(v));
const isEmpty = (v) =>
  v === "" ||
  v === null ||
  v === undefined ||
  (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);
const clearErrors = () => {
  for (const k in errors.value) {
    if (errors.value[k] && typeof errors.value[k] === "object") {
      for (const c in errors.value[k]) errors.value[k][c] = "";
    } else {
      errors.value[k] = "";
    }
  }
};
const handlePaddress = () => {
  if (form.c_address_population == 1 && form.p_address != userProfile.value.p_address) {
    form.c_address_population = 0;
  }
};
const setAddress = (val) => {
  if (val == 1) {
    console.log("userProfile.value", userProfile.value);

    form.p_address = userProfile.value.p_address;
    form.p_geography_id = userProfile.value.p_geography_id;
    form.p_province_code = userProfile.value.p_province_code;
    form.p_district_code = userProfile.value.p_district_code;
    form.p_subdistrict_code = userProfile.value.p_subdistrict_code;
    form.p_postal_code = userProfile.value.p_postal_code;
    form.full_p_address_th = userProfile.value.full_p_address_th;
    form.full_p_address_en = userProfile.value.full_p_address_en;
  } else if (val == 2) {
    console.log("assessmentData", assessmentData.value.detail.assessment);
    form.p_address = assessmentData.value.detail.assessment.p_address;
    form.p_geography_id = assessmentData.value.detail.assessment.p_geography_id;
    form.p_province_code = assessmentData.value.detail.assessment.p_province_code;
    form.p_district_code = assessmentData.value.detail.assessment.p_district_code;
    form.p_subdistrict_code = assessmentData.value.detail.assessment.p_subdistrict_code;
    form.p_postal_code = assessmentData.value.detail.assessment.p_postal_code;
    form.full_p_address_th = assessmentData.value.detail.assessment.full_p_address_th;
    form.full_p_address_en = assessmentData.value.detail.assessment.full_p_address_en;
  } else {
    form.p_address = "";
    form.p_geography_id = "";
    form.p_province_code = "";
    form.p_district_code = "";
    form.p_subdistrict_code = "";
    form.p_postal_code = "";
    form.full_p_address_th = "";
    form.full_p_address_en = "";
  }
};
const previewForm = (name, value) => {
  // แปลงค่าช่วย
  const showList = (obj, keys) => {
    return keys
      .map((k) => (obj?.[k] || "").trim())
      .filter(Boolean)
      .join(", ");
  };

  switch (name) {
    case "breastFeeding":
    case "measlesVaccinationHistory":
    case "historyOfTetanusVaccination": {
      const v =
        value === "" || value === null || value === undefined ? null : Number(value);
      const yesNoUnknown = { 0: "ไม่ทราบ", 1: "ใช่", 2: "ไม่ใช่" };
      return v in yesNoUnknown ? yesNoUnknown[v] : "";
    }

    // ✅ โครงใหม่
    case "historyOfAllergies": {
      let message;
      if (form.historyOfAllergies.value == 0) {
        message = "ไม่ทราบ";
      } else if (form.historyOfAllergies.value == 1) {
        message = "ไม่มี";
      } else if (form.historyOfAllergies.value == 2) {
        message = "มี";
      }
      return `${message}`;
      // new schema: { value, drug, food, other }
      // if (typeof form.historyOfAllergies === 'object') {
      //   const v = Number(form.historyOfAllergies.value ?? 0)
      //   const map = { 0: 'ไม่ทราบ', 1: 'ไม่มี', 2: 'มี' }
      //   const extras = showList(form.historyOfAllergies, ['drug', 'food', 'other'])
      //   const base = (v in map) ? map[v] : ''
      //   // return extras ? `${base}${base ? ' : ' : ''}${extras}` : base
      //    return extras ? `${base}` :''
      // }
      // // fallback legacy (number + other string)
      // const v = Number(value ?? 0)
      // const map = { 0: 'ไม่ทราบ', 1: 'แพ้ยา', 2: 'แพ้อาหาร', 3: 'อื่นๆ', 4: 'ไม่มี' }
      // if (!(v in map)) return ''
      // if (v === 3) {
      //   const extra = (form.historyOfAllergies.other || '').trim()
      //   return extra ? `อื่นๆ : ${extra}` : 'อื่นๆ'
      // }
      // return map[v]
    }

    case "pastHistory": {
      let message;
      if (form.pastHistory.value == 0) {
        message = "ไม่ทราบ";
      } else if (form.pastHistory.value == 1) {
        message = "ไม่มี";
      } else if (form.pastHistory.value == 2) {
        message = "มี";
      }
      return `${message}`;
      // new schema: { value, ht, dm, ba, other }
      // if (typeof form.pastHistory === 'object') {
      //   const v = Number(form.pastHistory.value ?? 0)
      //   const map = { 0: 'ไม่ทราบ', 1: 'ไม่มี', 2: 'มี'}
      //   const extras = showList(form.pastHistory, ['ht', 'dm', 'ba', 'other'])
      //   const base = (v in map) ? map[v] : ''
      //   // return extras ? `${base}${base ? ' : ' : ''}${extras}` : base
      //    return extras ? `${base}` :''
      // }
      // // fallback legacy
      // const v = Number(value ?? 0)
      // const map = { 0: 'ไม่ทราบ', 1: 'HT', 2: 'DM', 3: 'BA', 4: 'อื่นๆ', 5: 'ไม่มี' }
      // if (!(v in map)) return ''
      // if (v === 4) {
      //   const extra = (form.pastHistory.other || '').trim()
      //   return extra ? `อื่นๆ : ${extra}` : 'อื่นๆ'
      // }
      // return map[v]
    }

    case "drugHistory": {
      let message;
      if (form.drugHistory.value == 0) {
        message = "ไม่ทราบ";
      } else if (form.drugHistory.value == 1) {
        message = "ไม่มี";
      } else if (form.drugHistory.value == 2) {
        message = "มี";
      }
      return `${message}`;
      // new schema: { value, ht, dm, ba, other }
      // if (typeof form.drugHistory === 'object') {
      //   const v = Number(form.drugHistory.value ?? 0)
      //   const map = { 0: 'ไม่ทราบ', 1: 'ไม่มี', 2: 'มี' }
      //   const extras = showList(form.drugHistory, ['ht', 'dm', 'ba', 'other'])
      //   const base = (v in map) ? map[v] : ''
      //   // return extras ? `${base}${base ? ' : ' : ''}${extras}` : base
      //      return extras ? `${base}` :''
      // }
      // fallback legacy
      // const v = Number(value ?? 0)
      // const map = { 0: 'ไม่ทราบ', 1: 'HT', 2: 'DM', 3: 'BA', 4: 'อื่นๆ', 5: 'ไม่มี' }
      // if (!(v in map)) return ''
      // if (v === 4) {
      //   const extra = (form.drugHistory.other || '').trim()
      //   return extra ? `อื่นๆ : ${extra}` : 'อื่นๆ'
      // }
      // return map[v]
    }

    default: {
      const plain =
        value === "" || value === null || value === undefined ? "" : String(value);
      return plain;
    }
  }
};

const compactName = () => {
  let fullName = "-";
  if (form.c_prefix_name || form.c_first_name || form.c_last_name) {
    fullName = `${form.c_prefix_name || ""} ${form.c_first_name || ""} ${form.c_last_name || ""
      }`;
  }
  return fullName;
};
// helper
const deepPatch = (target, src) => {
  if (!src || typeof src !== "object") return;
  Object.keys(src).forEach((k) => {
    if (!(k in target)) return;
    const tv = target[k];
    const sv = src[k];
    if (tv && typeof tv === "object" && !Array.isArray(tv)) {
      deepPatch(tv, sv || {});
    } else {
      target[k] = sv;
    }
  });
};
const hasAnyValue = (obj) => {
  if (!obj || typeof obj !== "object") return false;
  const isFilled = (v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === "string") return v.trim() !== "";
    if (typeof v === "number") return !Number.isNaN(v);
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === "object") return Object.keys(v).length > 0;
    return true;
  };
  return Object.values(obj).some(isFilled);
};

/* ===== bits helpers (type2) ===== */
const normalizeBits = (bits, len) => {
  const arr = Array.isArray(bits) ? bits.map((x) => (Number(x) ? 1 : 0)) : [];
  if (arr.length < len) return arr.concat(Array(len - arr.length).fill(0));
  if (arr.length > len) return arr.slice(0, len);
  return arr;
};
const toBits = (options, selectedValues) => {
  const set = new Set((selectedValues || []).map((v) => String(v)));
  return options.map((o) => Number(set.has(String(o.value))));
};
const fromBits = (options, bits) =>
  options.filter((o, i) => bits?.[i]).map((o) => o.value);
const pickLabels = (options, selected) =>
  options.filter((o) => (selected || []).includes(o.value)).map((o) => o.label);

const viewLists = computed(() => ({
  trauma: pickLabels(traumaOptions, form.illness.trauma),
  infectious: pickLabels(infectiousOptions, form.illness.infectious),
  urgent: pickLabels(urgentOptions, form.illness.urgent),
  otherMajor: pickLabels(otherMajorOptions, form.illness.otherMajor),
  procedures: pickLabels(procedureOptions, form.care.procedures),
  outcomes: pickLabels(outcomeOptions, form.care.outcomes),
  relationships: pickLabels(relationshipOptions, form.context.relationships),
  prevention: pickLabels(preventionOptions, form.context.prevention),
}));
const buildDetail = () => ({
  illness: {
    a1: toBits(traumaOptions, form.illness.trauma),
    a2: toBits(infectiousOptions, form.illness.infectious),
    a3: toBits(urgentOptions, form.illness.urgent),
    a4: toBits(otherMajorOptions, form.illness.otherMajor),
    n1: form.illness.extraNote || "",
  },
  care: {
    b1: toBits(procedureOptions, form.care.procedures),
    b2: toBits(outcomeOptions, form.care.outcomes),
  },
  context: {
    c1: toBits(relationshipOptions, form.context.relationships),
    c2: toBits(preventionOptions, form.context.prevention),
    n2: form.context.extraNote || "",
  },
});

/* ===== API: populate (รองรับทั้ง type2 + type3) ===== */
const populateFormFromApi = (api = {}) => {
  const detail = api?.detail ?? {};

  // full form (เดิม type3) เก็บไว้ที่ detail.assessment
  const full = detail && typeof detail.assessment === "object" ? detail.assessment : {};

  // bits (เดิม type2) เก็บไว้ที่ detail.assessment_bits
  // และเผื่อเคส legacy ที่เคยยัด bits ไว้ใน assessment (ไม่มี vitalSigns)
  const bits =
    detail && typeof detail.assessment_bits === "object"
      ? detail.assessment_bits
      : full?.illness && full?.care && full?.context && !("vitalSigns" in full)
        ? full
        : null;

  try {
    // header/date
    if (api.datetime) form.datetime = new Date(api.datetime);
    if (api.type !== undefined) form.type = api.type;
    if (api.population_id !== undefined) form.population_id = api.population_id;
    if (detail.pregnancy !== undefined && detail.pregnancy !== null) {
      form.pregnancy = detail.pregnancy;
    }

    // ---- แพตช์ข้อมูล "full form" (เดิม type3) ----
    const incoming = { ...full };

    // ปรับ legacy -> schema ใหม่ (สามก้อนนี้)
    if (
      typeof incoming.historyOfAllergies === "number" ||
      typeof incoming.historyOfAllergies === "string"
    ) {
      incoming.historyOfAllergies = {
        value: Number(incoming.historyOfAllergies),
        drug: "",
        food: "",
        other: incoming.historyOfAllergiesOther || "",
      };
    } else if (
      incoming.historyOfAllergies &&
      typeof incoming.historyOfAllergies === "object"
    ) {
      incoming.historyOfAllergies.value = Number(incoming.historyOfAllergies.value ?? 0);
    }

    if (
      typeof incoming.pastHistory === "number" ||
      typeof incoming.pastHistory === "string"
    ) {
      incoming.pastHistory = {
        value: Number(incoming.pastHistory),
        ht: "",
        dm: "",
        ba: "",
        other: incoming.pastHistoryOther || "",
      };
    } else if (incoming.pastHistory && typeof incoming.pastHistory === "object") {
      incoming.pastHistory.value = Number(incoming.pastHistory.value ?? 0);
    }

    if (
      typeof incoming.drugHistory === "number" ||
      typeof incoming.drugHistory === "string"
    ) {
      incoming.drugHistory = {
        value: Number(incoming.drugHistory),
        ht: "",
        dm: "",
        ba: "",
        other: incoming.drugHistoryOther || "",
      };
    } else if (incoming.drugHistory && typeof incoming.drugHistory === "object") {
      incoming.drugHistory.value = Number(incoming.drugHistory.value ?? 0);
    }

    // ตัวเลข radio-like อื่น ๆ
    [
      "breastFeeding",
      "measlesVaccinationHistory",
      "historyOfTetanusVaccination",
      "c_gender",
      "c_address_population",
    ].forEach((k) => {
      if (incoming[k] !== undefined && incoming[k] !== null && incoming[k] !== "") {
        incoming[k] = Number(incoming[k]);
      }
    });

    if (incoming.datetime) {
      const dt = new Date(incoming.datetime);
      if (!isNaN(dt.getTime())) incoming.datetime = dt;
    }
    if (!incoming.vitalSigns || typeof incoming.vitalSigns !== "object") {
      incoming.vitalSigns = {};
    }

    // แพตช์เข้า form
    deepPatch(form, incoming);
    form.vitalSigns = { ...form.vitalSigns }; // คง reactive

    // ---- เติมข้อมูล “แบบบิต (เดิม type2)” จาก assessment_bits เสมอ ----
    if (bits) {
      const ill = bits.illness || {};
      form.illness.trauma = fromBits(
        traumaOptions,
        normalizeBits(ill.a1, traumaOptions.length)
      );
      form.illness.infectious = fromBits(
        infectiousOptions,
        normalizeBits(ill.a2, infectiousOptions.length)
      );
      form.illness.urgent = fromBits(
        urgentOptions,
        normalizeBits(ill.a3, urgentOptions.length)
      );
      form.illness.otherMajor = fromBits(
        otherMajorOptions,
        normalizeBits(ill.a4, otherMajorOptions.length)
      );
      form.illness.extraNote = ill.n1 ?? "";

      const care = bits.care || {};
      form.care.procedures = fromBits(
        procedureOptions,
        normalizeBits(care.b1, procedureOptions.length)
      );
      form.care.outcomes = fromBits(
        outcomeOptions,
        normalizeBits(care.b2, outcomeOptions.length)
      );

      const ctx = bits.context || {};
      form.context.relationships = fromBits(
        relationshipOptions,
        normalizeBits(ctx.c1, relationshipOptions.length)
      );
      form.context.prevention = fromBits(
        preventionOptions,
        normalizeBits(ctx.c2, preventionOptions.length)
      );
      form.context.extraNote = ctx.n2 ?? "";
    } else {
      // ถ้าไม่มี bits ให้เคลียร์ให้ชัดเจน (กันค่าค้าง)
      form.illness.trauma = [];
      form.illness.infectious = [];
      form.illness.urgent = [];
      form.illness.otherMajor = [];
      form.illness.extraNote = "";
      form.care.procedures = [];
      form.care.outcomes = [];
      form.context.relationships = [];
      form.context.prevention = [];
      form.context.extraNote = "";
    }
  } catch (e) {
    console.error("populateFormFromApi error:", e);
  }
};

// watch(isOnline, (newVal) => {
//   console.log("online changed:", newVal ? "ONLINE" : "OFFLINE");
//   if (route.params.populationFormId === "offline" && isOnline.value == true) {
//     router.push("/dashboard");
//   }
// });

const initPage = async () => {
  // ของเดิมที่อยู่ใน onMounted
  if (!checkNow() || route.params.populationFormId === "offline") {
    isOffline.value = true;
    console.log("checkNow", isOffline);

    const id = route.params.assessmentFormId;
    console.log("Offline mode for assessment id:", id);
    if (id && id !== "null" && id !== "undefined") {
      assessment_id.value = id;
      await fetchAssessment(id, true);
    } else {
      isEdit.value = true;
      errors.value.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
      errors.value.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
      errors.value.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    }
  }
  prefixStore.getAllPrefix();
  profileData.value = await useAuthStore().getProfile();
  console.log("mounted, isOnline:", isOnline.value);

  if (route.params.populationFormId) {
    population_id.value = route.params.populationFormId;
    await userPopulation
      .getPopulationById(route.params.populationFormId)
      .then((res) => {
        if (res.data.code == 200) {
          userProfile.value = res.data.data;
          setAddress(1);
        }
      })
      .catch(() => { });
  }

  const id = route.params.assessmentFormId;
  if ((id && id !== "null" && id !== "undefined")) {
    assessment_id.value = id;
    await fetchAssessment(id).then((res) => {
      console.log("wefwef", res);

      if (res) {
        assessmentData.value = res;
        setAddress(2);
      }
    });
  } else {
    isEdit.value = true;
    errors.value.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    errors.value.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    errors.value.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }
};

/* ===== lifecycle ===== */
onMounted(async () => {
  console.log('isOffline:', isOffline.value);
  console.log('isOnline:', isOnline.value);
  // if (route.params.populationFormId === "offline" && isOnline.value == true) {
  //   router.push("/dashboard");
  //   return;
  // }
   if (route.query.edit === 'true') {
    changeMode(true);
  }
  if (!checkNow() || route.params.populationFormId === "offline") {
    isOffline.value = true;
    console.log("checkNow", isOffline);
    const id = route.params.assessmentFormId;
    console.log("Offline mode for assessment id:", id);
    if (id && id !== "null" && id !== "undefined") {
      assessment_id.value = id;
      offLineData.value = await fetchAssessment(id, true);
      console.log("offLineData:", offLineData.value);
    } else {
      isEdit.value = true;
      errors.value.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
      errors.value.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
      errors.value.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    }

  }
  allPrefix.value = JSON.parse(localStorage.getItem('allPrefix') || '[]')
  prefixStore.getAllPrefix();
  profileData.value = await useAuthStore().getProfile();
  console.log("mounted, isOnline:", isOnline.value);

  if (route.params.populationFormId) {
    population_id.value = route.params.populationFormId;
    await userPopulation
      .getPopulationById(route.params.populationFormId)
      .then((res) => {
        if (res.data.code == 200) {
          userProfile.value = res.data.data;
          setAddress(1);
        }
      })
      .catch(() => { });
  }

  const id = route.params.assessmentFormId;
  if (id && id !== "null" && id !== "undefined") {
    assessment_id.value = id;
    if (isOffline.value == true) {
      await fetchAssessment(id, true).then((res) => {
        console.log("wefwef", res);

        if (res) {
          assessmentData.value = res;
          setAddress(2);
        }
      });
    } else {
      await fetchAssessment(id).then((res) => {
        console.log("wefwef", res);

        if (res) {
          assessmentData.value = res;
          setAddress(2);
        }
      });
    }

  } else {
    isEdit.value = true;
    errors.value.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    errors.value.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
    errors.value.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }
});
watch(
  isDirty,
  (dirty) => {
    if (dirty) {
      console.log("ข้อมูลที่อยู่ (p_*) เปลี่ยนจากโปรไฟล์แล้ว");
    }
  },
  { immediate: true }
);

/* ===== fetch ===== */
async function fetchAssessment(id, offline = false) {
  try {
    if (offline) {
      const list = await getOfflineAssessments();

      const record = list.find((item) => String(item.id) === String(id));

      if (!record) {
        console.warn("No offline assessment found for id:", id);
        return null;
      }

      const payload = record.data || record;
      console.log("payload", payload);
      console.log('form.pregnancy')

      created_name.value = payload?.created_name || record.name || "";
      assessment_count.value = payload?.assessment_count ?? 0;
      image.value = payload.image;
      imageSize.value = payload.image_size;
      // form?.c_gender

      populateFormFromApi(payload || {});
      // isEdit.value = false;
      if (route.query.edit === 'true') {
        changeMode(true);
      }

      takeSnapshot();

      return payload;
    }
    const { data } = await axios.get("/assessment/" + id);
    const payload = data && typeof data === "object" && data.data ? data.data : data;

    pdfUrl.value = payload.download.pdf_download;
    imageUrl.value = payload.download.image_download;
    console.log("PDF URL:", pdfUrl.value);

    created_name.value = payload?.created_name || "";
    assessment_count.value = payload?.count || 0;
    image.value = payload.image;
    imageSize.value = payload.image_size;
    populateFormFromApi(payload || {});
    isEdit.value = false;
    takeSnapshot();
    return payload;
  } catch (e) {
    console.error("fetchAssessment error:", e);
    return null;
  }
}

/* ===== DatePicker sync ===== */
const selectCreateDate = (date) => {
  form.datetime = date;
};

/* ===== cancel ===== */
const cancelAssessment = () => {
  if (assessment_count.value > 0) {
    restoreFromSnapshot();
    clearErrors();
    changeMode(false);
  }

 
  // else {
  //   router.push("/");
  // }

  if (route?.query?.from) {
    router.push({ path: route?.query?.from });
    return;
  }
  else if (window.history.length > 1) {
    router.go(-1);
  } 

  console.log(window?.history)
  console.log(router?.options?.history?.state?.back)
  console.log(route?.query?.from);
  


};

/* ===== validate (แตกกิ่งตาม type) ===== */
const validateForm = () => {
  clearErrors();
  normalizeHistoryObjects();
  let ok = true;

  if (!form.datetime || isNaN(new Date(form.datetime).getTime())) {
    console.log("datetime");
    ok = false;
    errors.value.datetime = "โปรดเลือกวันที่ประเมิน";
  }

  // ✅ ตรวจ illness ว่ามีเลือกอย่างน้อย 1 หมวดไหม
  const { trauma = [], infectious = [], urgent = [], otherMajor = [] } =
    form.illness || {};
  const noIllnessSelected =
    (!trauma || trauma.length === 0) &&
    (!infectious || infectious.length === 0) &&
    (!urgent || urgent.length === 0) &&
    (!otherMajor || otherMajor.length === 0);

  if (noIllnessSelected) {
    console.log("illness");

    ok = false;
    if (!errors.value.illness) errors.value.illness = {};
    errors.value.illness.message = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }
  if (form.care.outcomes.length === 0) {
    ok = false;
    errors.value.care.outcomesMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }
  if (form.context.relationships.length === 0) {
    ok = false;
    errors.value.context.relationshipsMessage = "โปรดเลือกอย่างน้อย 1 ตัวเลือก";
  }

  if (Number(form.historyOfAllergies.value) === 2) {
    const filled = ["drug", "food", "other"].some((k) =>
      (form.historyOfAllergies[k] || "").trim()
    );
    if (!filled) {
      console.log("historyOfAllergies");

      ok = false;
      errors.value.historyOfAllergiesMessage =
        "กรุณาระบุรายละเอียดการแพ้ (ยา/อาหาร/อื่นๆ)";
    }
  }
  if (Number(form.pastHistory.value) === 2) {
    const filled = ["ht", "dm", "ba", "other"].some((k) =>
      (form.pastHistory[k] || "").trim()
    );
    if (!filled) {
      console.log("pastHistory");

      ok = false;
      errors.value.pastHistoryMessage = "กรุณาระบุรายละเอียดประวัติ (HT/DM/BA/อื่นๆ)";
    }
  }
  if (Number(form.drugHistory.value) === 2) {
    const filled = ["ht", "dm", "ba", "other"].some((k) =>
      (form.drugHistory[k] || "").trim()
    );
    if (!filled) {
      console.log("drugHistory");

      ok = false;
      errors.value.drugHistoryMessage = "กรุณาระบุรายละเอียดการใช้ยา (HT/DM/BA/อื่นๆ)";
    }
  }

  // ตรวจข้อมูลทั่วไป
  // if (String(form.type) === '3' || form.type === 3) {
  // if (isEmpty(form.c_prefix_id)) {
  //   ok = false;
  //   errors.value.c_prefix_id = "โปรดเลือกคำนำหน้า";
  // }
  // if (isEmpty(form.c_first_name)) {
  //   ok = false;
  //   errors.value.c_first_name = "โปรดกรอกชื่อ";
  // }
  // if (isEmpty(form.c_last_name)) {
  //   ok = false;
  //   errors.value.c_last_name = "โปรดกรอกนามสกุล";
  // }
  // if (isEmpty(form.phone)) {
  //   ok = false;
  //   errors.value.phone = "โปรดกรอกนามสกุล";
  // }
  // if (isEmpty(form.c_gender)) {
  //   ok = false;
  //   errors.value.c_gender = "โปรดระบุเพศ";
  // }

  // if (isEmpty(form.p_province_code)) {
  //   ok = false;
  //   errors.value.p_province_code = "โปรดเลือกจังหวัด";
  // }
  // if (isEmpty(form.p_district_code)) {
  //   ok = false;
  //   errors.value.p_district_code = "โปรดเลือกเขต/อำเภอ";
  // }
  // if (isEmpty(form.p_subdistrict_code)) {
  //   ok = false;
  //   errors.value.p_subdistrict_code = "โปรดเลือกแขวง/ตำบล";
  // }
  // if (isEmpty(form.p_postal_code)) {
  //   ok = false;
  //   errors.value.p_postal_code = "โปรดระบุรหัสไปรษณีย์";
  // } else if (!/^\d{5}$/.test(String(form.p_postal_code))) {
  //   ok = false;
  //   errors.value.p_postal_code = "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก";
  // }
  // if (isEmpty(form.p_address)) {
  //   ok = false;
  //   errors.value.p_address = "โปรดกรอกที่อยู่";
  // }
  // }
  // console.log("ok :::: ", ok);
  // console.log("errors :::: ", errors.value);

  return ok;
};
function normalizeHistoryObjects() {
  // ถ้าโดน v-model เขียนทับทั้งก้อนเป็น '2' หรือ 2 ให้แปลงกลับเป็นอ็อบเจ็กต์
  const fix = (node, shape) => {
    if (typeof node !== "object" || node === null) {
      const v = Number(node ?? 0);
      return { value: Number.isFinite(v) ? v : 0, ...shape };
    }
    // บังคับให้มี value เป็นตัวเลข และคีย์อื่นๆ เป็นสตริงเสมอ
    return {
      value: Number(node.value ?? 0),
      ...Object.fromEntries(Object.keys(shape).map((k) => [k, String(node[k] ?? "")])),
    };
  };

  form.historyOfAllergies = fix(form.historyOfAllergies, {
    drug: "",
    food: "",
    other: "",
  });
  form.pastHistory = fix(form.pastHistory, { ht: "", dm: "", ba: "", other: "" });
  form.drugHistory = fix(form.drugHistory, { ht: "", dm: "", ba: "", other: "" });
}
// รัน validate ทุกครั้งที่ฟอร์มเปลี่ยน + ตอนเมานท์ครั้งแรก
watch(
  form,
  () => {
    const { ok, errors: snap } = computeErrorsSnapshot();
    errors.value = snap; // โครงครบ จึงไม่ undefined แน่นอน
    canSave.value = ok;
  },
  { deep: true }
);

const validateRequiredForm = (form) => {
  console.log("before validateForm", JSON.parse(JSON.stringify(form)));

  submitted.value = true;
  const e = makeEmptyErrors();
  let ok = true;

  if (isEmpty(form.c_prefix_id)) {
    ok = false;
    e.c_prefix_id = "โปรดเลือกคำนำหน้า";
  }
  if (isEmpty(form.c_first_name)) {
    ok = false;
    e.c_first_name = "โปรดกรอกชื่อ";
  }
  if (isEmpty(form.c_last_name)) {
    ok = false;
    e.c_last_name = "โปรดกรอกนามสกุล";
  }
  if (isEmpty(form.phone)) {
    ok = false;
    e.phone = "โปรดกรอกเบอร์โทรศัพท์";
  }
  // if (isEmpty(form.c_gender)) {
  //   ok = false;
  //   e.c_gender = "โปรดระบุเพศ";
  // }

  // if (isEmpty(form.p_province_code)) {
  //   ok = false;
  //   e.p_province_code = "โปรดเลือกจังหวัด";
  // }
  // if (isEmpty(form.p_district_code)) {
  //   ok = false;
  //   e.p_district_code = "โปรดเลือกเขต/อำเภอ";
  // }
  // if (isEmpty(form.p_subdistrict_code)) {
  //   ok = false;
  //   e.p_subdistrict_code = "โปรดเลือกแขวง/ตำบล";
  // }

  // if (isEmpty(form.p_postal_code)) {
  //   ok = false;
  //   e.p_postal_code = "โปรดระบุรหัสไปรษณีย์";
  // } else if (!/^\d{5}$/.test(String(form.p_postal_code))) {
  //   ok = false;
  //   e.p_postal_code = "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก";
  // }

  // if (isEmpty(form.p_address)) {
  //   ok = false;
  //   e.p_address = "โปรดกรอกที่อยู่";
  // }

  errors.value = e;
  console.log("required errors", e);

  return ok;
};

/* ===== save (แตกกิ่งตาม type) ===== */
const takeAssessment = async () => {
  // if (!validateRequiredForm(form)) return;

  if (!validateForm()) {
    normalizeHistoryObjects();
    const { ok, errors: e } = computeErrorsSnapshot();
    errors.value = e;
    console.warn("ฟอร์มไม่ผ่านการตรวจสอบ");
    console.log("validateForm result =", result);
    return;
  }

  // console.log('เบอร์', form?.phone.length < 10)
  if (form?.phone?.length < 10 && isOffline.value == true) {
    errPhone.value = "โปรดกรอกเบอร์โทรศัพท์ที่ติดต่อ ให้ถูกต้อง";

    nextTick(() => {
      document
        .getElementById("errphone")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    return;
  } else {
    errPhone.value = "";
  }

  // ถ้ากำหนดที่อยู่เอง ให้ประกอบ full address
  // ถ้ากำหนดที่อยู่เอง ให้ประกอบ full address
  if (form.c_address_population == 0) {
    const result = resolveAddress({
      provinceCode: form.p_province_code,
      districtCode: form.p_district_code,
      subdistrictCode: form.p_subdistrict_code,
    });

    const isBangkok = String(form.p_province_code) === "10";

    const join = (...arr) => arr.filter(Boolean).join(" ");

    form.full_p_address_th = isBangkok
      ? join(
        form.p_address,
        result.subdistrictTh && `แขวง ${result.subdistrictTh}`,
        result.districtTh && `เขต ${result.districtTh}`,
        "จ.กรุงเทพมหานคร",
        result.postalCode
      )
      : join(
        form.p_address,
        result.subdistrictTh && `ต.${result.subdistrictTh}`,
        result.districtTh && `อ.${result.districtTh}`,
        result.provinceTh && `จ.${result.provinceTh}`,
        result.postalCode
      );

    form.full_p_address_en = isBangkok
      ? join(
        form.p_address,
        result.subdistrictEn,
        result.districtEn,
        "Bangkok",
        result.postalCode
      )
      : join(
        form.p_address,
        result.subdistrictEn,
        result.districtEn,
        result.provinceEn,
        result.postalCode
      );
  }

  // โครง bit (เดิมของ type2) จะสร้างจากสถานะปัจจุบันของฟอร์มเสมอ
  const bits = buildDetail();

  // ฟอร์มเต็ม (เดิมของ type3) ส่งทั้งก้อนเสมอ
  const fullForm = {
    c_prefix_id: form.c_prefix_id,
    c_prefix_name: form.c_prefix_name,
    c_first_name: form.c_first_name,
    c_last_name: form.c_last_name,
    // offline
    birth_date: form.birth_date,
    age: form.age,
    gender: form.gender,
    phone: form.phone,
    c_nick_name: form.c_nick_name,
    c_gender: form.c_gender,
    c_address_population: form.c_address_population,

    p_province_code: form.p_province_code,
    p_district_code: form.p_district_code,
    p_subdistrict_code: form.p_subdistrict_code,
    p_postal_code: form.p_postal_code,
    p_address: form.p_address,
    p_geography_id: form.p_geography_id,
    full_p_address_th: form.full_p_address_th,
    full_p_address_en: form.full_p_address_en,

    breastFeeding: form.breastFeeding,
    headCircumference: form.headCircumference,
    measlesVaccinationHistory: form.measlesVaccinationHistory,
    historyOfTetanusVaccination: form.historyOfTetanusVaccination,

    // ✅ ใช้สกีมาใหม่ตรง ๆ
    historyOfAllergies: { ...form.historyOfAllergies },
    pastHistory: { ...form.pastHistory },
    drugHistory: { ...form.drugHistory },

    importantSymptoms: form.importantSymptoms,
    vitalSigns: { ...form.vitalSigns },
    historyOfCurrentIllness: form.historyOfCurrentIllness,
    diagnosis: form.diagnosis,
    drugNameDrugSizeHowToUse: form.drugNameDrugSizeHowToUse,
    additionalNotes: form.additionalNotes,
  };

  // รวม payload เดียว ไม่แยก type
  // ส่งทั้ง assessment (ฟอร์มเต็ม) และ assessment_bits (โครง bit เดิม) เพื่อความเข้ากันได้ย้อนกลับ
  let payload = {
    image: image.value,
    image_size: imageSize.value,
    datetime: formatDateYMD(form.datetime),
    population_id: population_id?.value ?? population_id,
    // จะคงค่า type เดิมไว้ก็ได้ แต่ backend ไม่จำเป็นต้องใช้แล้ว
    type: form.type,
    assessment_count: "-", //Number(assessment_count.value ?? 0) + 1
    detail: {
      pregnancy: form.pregnancy,
      assessment: fullForm, // โครงเต็ม (เดิม type3)
      assessment_bits: bits, // โครง bit (เดิม type2)
    },
    create_by: userData.value?.fullname || "-",
  };

  let api_path;
  if (assessment_id.value) {
    payload.id = assessment_id.value;

    if (payload.image && !isURL(payload.image)) {
      payload.image = payload.image;
    } else {
      // delete payload.image;
    }
    if (isURL(payload.image)) {
      delete payload.image;
    }

    // if (payload.image === undefined) {
    // delete payload.image;
    // }

    api_path = "/assessment/" + assessment_id.value;
  } else {
    api_path = "/assessment";
  }

  if (payload.create_by === undefined || payload.create_by === null) {
    delete payload.create_by;
  }

  let formData = new FormData();
  const body = $buildFormData(formData, payload);

  if (isOffline.value == true) {
    if (payload.image instanceof File || payload.image instanceof Blob) {
      payload.image = await fileToBase64(payload.image);
    }

    if (assessment_id.value) {
      console.log("wdwd2", payload);
      const item = await updateOfflineAssessment(assessment_id.value, payload, undefined, false);
      isEdit.value = false;
      assessment_id.value = item.id;
      console.log("บันทึกแบบประเมินออฟไลน์:", item);
      image.value = item.data?.image ?? null;
      assessment_count.value = item.data?.assessment_count ?? null;

      statusModal.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
        timeout: 5000,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
      });
      // router.push({
      //   name: "offline-assessment",
      //   query: {
      //     success: "1",
      //   },
      // });
      // statusModal.value.openModal("success", {
      //   header: "ดำเนินการสำเร็จ !",
      //   subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
      //   closeButtonText: "ปิดหน้าต่าง",
      //   timeout: 5000,
      // });
      return;
    } else {
      console.log("wdwd1", payload.image);
      const item = await addOfflineAssessment(payload, payload.type);
      isEdit.value = false;
      assessment_id.value = item.id;
      console.log("บันทึกแบบประเมินออฟไลน์:", item);
      image.value = item.data?.image ?? null;
      assessment_count.value = item.data?.assessment_count ?? null;

      statusModal.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
        timeout: 5000,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
      });

      // router.push({
      //   name: "offline-assessment",
      //   query: {
      //     success: "1",
      //   },
      // });
      // statusModal.value.openModal("success", {
      //   header: "ดำเนินการสำเร็จ !",
      //   subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
      //   closeButtonText: "ปิดหน้าต่าง",
      //   timeout: 5000,
      // });
      return;
    }
  } else {
    console.log("bady", payload);

    axios
      .post(api_path, body)
      .then(async (res) => {
        if (res.data.code == 200) {
          isEdit.value = false;
          assessment_id.value = res.data.data.id;
          assessment_count.value = res.data.data.count;
          created_name.value = res.data.data.created_name;
          image.value = res.data.data.image;
          imageSize.value = res.data.data.image_size;
          // fetchAssessment(route.params.assessmentFormId);
          statusModal.value.openModal("success", {
            header: "ดำเนินการสำเร็จ !",
            subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
            closeButtonText: "ปิดหน้าต่าง",
            timeout: 5000,
          });
          window.scrollTo({
            top: 0,
            behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
          });

          await fetchAssessment(res.data.data.id);
        } else {
          statusModal.value.openModal("error", {
            header: "เกิดความผิดพลาด !",
            subHeader: res.data.message,
            closeButtonText: "ปิดหน้าต่าง",
          });
        }
      })
      .catch((err) => {
        statusModal.value.openModal("error", {
          header: "เกิดความผิดพลาด !",
          subHeader: err?.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้",
          closeButtonText: "ปิดหน้าต่าง",
        });
      });
  }
};

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const downloadPdf = async () => {
  try {
    const timestamp = Date.now(); // millisecond
    const baseName = `report_${timestamp}`;

    // ===== PDF =====
    if (pdfUrl.value) {
      const pdfResp = await axios.get(pdfUrl.value, { responseType: "blob" });
      const pdfBlob = new Blob([pdfResp.data], { type: "application/pdf" });

      const pdfLink = document.createElement("a");
      const pdfUrlObj = window.URL.createObjectURL(pdfBlob);
      pdfLink.href = pdfUrlObj;
      pdfLink.setAttribute("download", `${baseName}.pdf`);

      document.body.appendChild(pdfLink);
      pdfLink.click();
      pdfLink.remove();
      window.URL.revokeObjectURL(pdfUrlObj);

      console.log("PDF downloaded!");
    }

    // ===== IMAGE =====
    if (imageUrl.value) {
      const imgResp = await axios.get(imageUrl.value, { responseType: "blob" });

      // เดานามสกุลไฟล์จาก content-type
      const contentType = imgResp.headers["content-type"];
      const ext = contentType?.split("/")[1] || "png";

      const imgBlob = new Blob([imgResp.data], { type: contentType || "image/png" });

      const imgLink = document.createElement("a");
      const imgUrlObj = window.URL.createObjectURL(imgBlob);
      imgLink.href = imgUrlObj;
      imgLink.setAttribute("download", `${baseName}.${ext}`);

      document.body.appendChild(imgLink);
      imgLink.click();
      imgLink.remove();
      window.URL.revokeObjectURL(imgUrlObj);

      console.log("Image downloaded!");
    }
  } catch (error) {
    console.error("Error downloading files:", error);
  }
};

// const opt = {
//   margin: [10, 10, 10, 10], // mm
//   filename: `report-${Date.now()}.pdf`,
//   image: { type: "jpeg", quality: 0.98 },
//   html2canvas: {
//     scale: 2,
//     useCORS: true,
//     ignoreElements: (el) => el.classList.contains("no-export"),
//     onclone: (doc) => {
//       doc.body.classList.add("exporting");
//     },
//   },
//   jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//   pagebreak: {
//     mode: ["css", "legacy"],
//     before: ".page-break-before",
//     after: ".page-break-after",
//     avoid: [".page-break-avoid", ".page-keep"],
//   },
// };
// html2pdf().set(opt).from(el).save();

const selectBirthDate = (date) => {
  form.birth_date = date;
};

watch(
  () => form.birth_date,
  (newVal) => {
    form.age = $CalAge(newVal);
  }
);
</script>

<style lang="scss" scoped>
.title {
  color: var(--text-color-text-grey-darkest, #1f1d1f);
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  letter-spacing: 0.1px;
}

@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}

.set380 {
  width: 100%;

  @media screen and (min-width: 380px) {
    width: fit-content !important;
  }
}

.fontSize14{
  font-size: 14px;
}
</style>
